// @flow
import React, { useEffect, useState } from "react";
import {
    Icon,
    IconCheckSolid,
    IconRedCross,
    IconInfo
} from '../../../base/icons';

import { makeStyles } from "@material-ui/core";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import { getPublicIp } from "../../../webjam/helper";
import { sendData } from "../../../webjam/websocket";
import { usePrevious } from "../../welcome-dashboard/Utils";
import {
    FEATURE_CUSTOM_PAYMENT,
    FEATURE_CUSTOM_REDUX,
    FEATURE_CUSTOM_REDUX_V2,
    FEATURE_CUSTOM_REDUX_V3,
    prejoinDetectDeviceEmitter
} from "../../constant";
import Spinner from '@atlaskit/spinner';
// import SpinnerLoader from "./"
import { setData, setPrejoinDeviceCode } from "../../redux/tool-webjam/actions";
import { getDeviceMessage, getDeviceStatus, getUserBox, prejoinDeviceCalc } from "../../welcome-dashboard/Request.d";
import {
    setAvilableUserIP,
    setBrowserDeviceStatus,
    setDetectDeviceTimer,
    setDeviceContainerStatus,
    setDeviceInfoMessage,
    setEnableWebjamModal,
    setJoinRoomWithoutDevice,
    setPrejoinDeviceConnection,
    setPrejoinScreenDetail,
    setPrejoinSocketDWaiting,
    setPrejoinStepFlag,
    setUserDeviceDetecting,
    setZendeskState
} from "../../redux/tool-webjam-v2/actions";
import { DEVICE_DETECT_STEP, DEVICE_INFO_MESSAGES, DEVICE_INFO_MESSAGES_KEYS, infoMessages, INFO_CODE, RUNNING_PROCESS_TIGGER_POINT, systemBootMessage, WAITING_TIME } from "./deviceInfoMessage";
import { Tooltip } from "@material-ui/core"
import {
    MultipleDeviceList,
    ShowDeviceMessageModal, ThemedModal, userHasSubscription
} from "./HelperComponent"
import { checkInternetSpeed, getBaseConfig, getLastKey, getQueryString, getStore, InvitedUserConfirmFlag, isSocialMobileApp, prejoinDeviceCalculateFlag, randomString, sleep, TEMP_ROOM, _startConference, _ValidateIPaddress, calculateTimeDiff } from "../../Utils";
import { socketOn } from "../../../../../socket";
import _, { isEqual } from "lodash";
import { connect } from "../../../base/redux";
import UserSubscription from "./UserSubscription";
import { getMySubscription, getPackageList } from "../../welcome-dashboard/paymentRequest";
import toast from "react-simple-toasts";
import { stripeMessage } from "../../welcome-dashboard/messages";
import { SaveLog } from '../../Utils';
import { setInvitedUserMState, setPrejoinDeviceMessages, setPrejoinDeviceConnectTime, setPrejoinDevicePingCalculate, setPrejoinDeviceStepRunning, setPrejoinLoader, setPrejoinScreenUserRoute, setPrejoinSubscriptionUI, setUserPrejoinAllSet, setUserStaticDeviceId, setPremeetingSubscriptionUI, setShowDevicePreConnection } from "../../redux/tool-webjam-v3/actions";
import { setSubscriptionPackage } from "../../welcome-dashboard/components/payment/payment-reducer/actions";
import { CURRENT_ROOM_NAME } from "../../../webjam/constant";
import { MEDIA_TYPE, setAudioMuted, setVideoMuted, VIDEO_MUTISM_AUTHORITY } from "../../../base/media";
import { muteLocal } from "../../../video-menu/actions.any";
import Zendesk from "react-zendesk";
// import { Icon } from "../../../base/icons";
import SpinnerLoader from "./SpinnerLoader";
import { ct, dynamicMessageLocale } from "../../constant-Utils";
import { i18next } from "../../../base/i18n";
import CopyLinkPop from "./CopyLinkPop";

const ZENDESK_KEY = "a66186d6-1905-41e1-829a-1fff879d1520";

const setting = {
    color: {
        theme: "var(--theme-primary-color) !important"
    },
    position: { horizontal: 'right', vertical: 'top' },
    launcher: {
        chatLabel: {
            '*': 'Chat now'
        },
        mobile: {
            labelVisible: true
        },
    },
    contactForm: {
        fields: [
            { id: "description", prefill: { "*": " " } }
        ]
    },
};




const useStyles = makeStyles(theme => {
    let { conferenceJoined } = getStore(FEATURE_CUSTOM_REDUX);
    return {
        deviceStatus: {
            // alignItems: 'center',
            color: '#fff',
            fontSize: '14px',
            lineHeight: '20px',
            padding: '6px',
            // marginTop: "15px",
            // '& span': {
            //     marginLeft: theme.spacing(3)
            // },

            '&.device-status-error': {
                alignItems: 'flex-start',
                backgroundColor: theme.palette.warning01,
                borderRadius: '6px',
                color: theme.palette.uiBackground,
                padding: '12px 16px',
                textAlign: 'left'
            },
            '& .device-icon': {
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                // display: 'inline-block',
                height: '16px',
                width: '16px'
            },
            '& .device-icon--ok svg path': {
                fill: 'var(--theme-primary-color) !important'
            },
            '& .device-icon--warning svg path': {
                fill: 'red !important'
            }
        },
        marginTopNgThirtn: {
            marginTop: getBaseConfig("noDevicePreJoiningScreen") && !conferenceJoined ? "0px !important" : "-13px !important"
        }
    };
});

const STATUS_FLAG = {
    AUDIO: "AUDIO",
    VIDEO: "VIDEO",
    CHECK_INTERNET: "CHECK_INTERNET",
    DETECT_DEVICE: "DETECT_DEVICE",
    CONNECT_DEVICE: "CONNECT_DEVICE",
    DETECT_INTERFACE: "DETECT_INTERFACE",
}


let TIME_LIMIT = 40;

const DeviceRoomInfo = (props) => {

    const dispatch = useDispatch();

    let [showAudio, setShowAudio] = useState(false)
    let [showVideo, setShowVideo] = useState(false)

    let [connectRequested, setConnectRequested] = useState(false)
    let [deviceConnected, setDeviceConnected] = useState(false)
    let [clickedReboot, setClickedReboot] = useState(false)

    let [interfaceStatus, setInterfaceStatus] = useState({
        willShow: false,
        isDetecting: false,
        isDetected: false,
        isDetectingFailed: false
    })

    let [deviceStatus, setDeviceStatus] = useState({
        willShow: false,
        isDetecting: false,
        devicePairing: false,
        devicePaired: false,
        isDetectingFailed: false,
        connectFailed: false,
        infoCode: ""
    })

    let [internetMeasure, setInternetMeasture] = useState({
        willShow: false,
        isDetecting: false,
        isDetectingFailed: false,
        speed: 0,
        showSpeed: false
    })

    const [infoMessagesView, setInfoMessageView] = useState({})
    const [userRebootTimer, setUserRebootTimer] = useState(0)

    let [getDeviceId, setDeviceId] = useState("");
    let [getDeviceIp, setDeviceIp] = useState("");

    let [isSeekingInterface, setIsSeekingInterface] = useState(false)

    const [showSubscription, setShowSubscription] = useState(false)

    const [flagType, setFlagType] = useState("")

    let [init, setInit] = useState(true)
    let [systemInit, setSystemInit] = useState("")

    const [myStaticDevice, setMyStaticDevice] = useState("")
    const [userDeviceSubmit, setUserDeviceSubmit] = useState(false);

    const [isSocketReceived, setIsSocketReceived] = useState(false)
    const [packageList, setPackageList] = useState([])

    const [showPageLoader, setShowPageLoader] = useState(false)
    const [showMultiDevice, setShowMultiDevice] = useState(false)
    const [showAllPackage, setShowAllPackage] = useState(true)
    const [showMobileModalLink, setShowMobileModalLink] = useState("")
    const [tryingToReconnect, setTryingToReconnect] = useState(0)
    const [copyLink, setCopyLink] = useState < { show: boolean, link: string, isCopied: boolean } > ({
        show: false,
        link: "",
        isCopied: false
    })

    const {
        availableDevices,
        permissions,
        mediaAllowed
    } = props;

    const {
        deviceList,
        roomorIpAddress,
        protocolId,
        usersData,
        uniqueId
    } = useSelector(state => state[FEATURE_CUSTOM_REDUX])

    const {
        prejoinDeviceConnection,
        prejoinScreenDetail,
        registeredDevice,
        detectDeviceTimer
    } = useSelector(state => state[FEATURE_CUSTOM_REDUX_V2])


    const [isRecheckingDevice, setRecheckingDevice] = useState(false)

    useEffect(function () {
        // if (deviceStatus.infoCode) {

        // }
        // console.log("device status updated ", deviceStatus)
        dispatch(setPrejoinDeviceCode(deviceStatus.infoCode))
    }, [deviceStatus]);

    useEffect(() => {
        socketOn("user_subscription", data => {
            const { userLoginData } = props;
            let { windowRef, prejoinSubscription } = getStore(FEATURE_CUSTOM_PAYMENT);

            let store_v1 = getStore(FEATURE_CUSTOM_REDUX)
            console.log("userLoginData ", userLoginData.user, "data ", data, "windowRef", windowRef)
            if (userLoginData.user) {
                try {
                    console.log("data user_id ", data.user_id, "user id ", userLoginData.user?.id)
                    if (data.user_id == userLoginData.user?.id) {
                        if (windowRef.package_id == data.package_id) {

                            dispatch(getMySubscription(null, 2));
                            dispatch(setPrejoinLoader(true))
                            setTimeout(function () {
                                dispatch(setPrejoinLoader(false))
                            }, 8000);

                            // updateSubscriptionUI(true)
                            // checkUserSubsFn()
                            // comment below code because it block success message page after payment on stripe
                            // windowRef.win.close();
                            // toast(stripeMessage.subscriptionPurchased, 5000)


                            setTimeout(function () {

                                setShowSubscription(false);
                                // showUSubscription()
                                // dispatch(setDeviceInfoMessage({
                                //     show: true,
                                //     messages: [],
                                //     info_code: INFO_CODE.ALL_SET
                                // }))
                                // updateSubscriptionUI()

                            }, 5000)
                            // console.log("user subscription purchased")
                        }
                    }
                } catch (e) {
                    console.log(
                        "socket error ", e
                    )
                }
            }
        })

        getPackageList().then(async res => {
            if (res.status == 1) {
                let data = res?.data?.data;
                let finalData = {};

                if (data && data.length) {
                    data = await Promise.all(data.map(async main => {
                        main.features = await Promise.all(main.features.map(async feature => {
                            feature.descriptions = await Promise.all(feature.descriptions.map(async description => {
                                return await dynamicMessageLocale(description)
                            }))
                            feature.title = await dynamicMessageLocale(feature.title)
                            return feature;
                        }))
                        return main;
                    }))

                    for (let i = 0; i < data.length; i++) {
                        if (data[i].package_type != undefined) {
                            if (finalData[data[i].package_type] == undefined) {
                                finalData[data[i].package_type] = []
                            }
                            finalData[data[i].package_type].push(data[i])
                        }
                    }
                }
                if (Object.keys(finalData).length) {
                    dispatch(setSubscriptionPackage(finalData))
                } else {
                    dispatch(setSubscriptionPackage({}))
                }
            }
        })
        setTimeout(async function () {
            getAvailableDevice()
        }, 100)

        // setTimeout(() => {
        //     dispatch(setInvitedUserMState(true));
        // },4000)
    }, [])

    const getAvailableDevice = async () => {
        let publicIp = getDeviceIp;
        if (!publicIp) {
            publicIp = await getPublicIp();
            setDeviceIp(publicIp)
        }

        let roomStatus = await getDeviceStatus({
            device_ip: publicIp
        });

        let returnData = {
            availableDevice: [],
            data: {},
            status: 0
        }

        if (roomStatus.status == 1) {
            if (roomStatus.availableDevice.length) {
                returnData.availableDevice = roomStatus.availableDevice;
            }
            returnData.data = roomStatus;
            returnData.status = 1;
        } else if (roomStatus.hasOwnProperty("availableDevice")) {
            if (roomStatus.availableDevice.length) {
                returnData.availableDevice = roomStatus.availableDevice;
            }
        }

        deviceList.map(e => returnData.availableDevice.push(e));
        if (returnData.availableDevice.length) {
            returnData.availableDevice = [...new Set(returnData.availableDevice)];
        }

        return returnData;
    }

    useEffect(function () {
        if (flagType) {
            if (flagType == STATUS_FLAG.VIDEO) {
                setTimeout(function () {
                    let willMove = browserDeviceStatus.video;
                    if (willMove.status) {
                        sessionStorage.removeItem("userWebcamDenied")
                    } else {
                        if (willMove.infoCode) {
                            if (!sessionStorage.getItem("userWebcamDenied")) {
                                if (!sessionStorage.getItem("video")) {
                                    // console.log("=> willMove.infoCode  2", willMove.infoCode)

                                    handleInfoClick(willMove.infoCode)
                                }
                            }
                        }
                    }
                    // getStatus(STATUS_FLAG.CHECK_INTERNET)
                }, 1000)
            }
        }
    }, [flagType])

    useEffect(() => {
        dispatch(setPrejoinStepFlag(flagType))
    }, [flagType])


    const initCheckDevice = (flag = null, from = null) => {
        let initSet = {
            show: true,
            messages: {
                [DEVICE_INFO_MESSAGES_KEYS.CHECK_DEVICE_INTERNET]: {
                    ...DEVICE_INFO_MESSAGES[DEVICE_INFO_MESSAGES_KEYS.CHECK_DEVICE_INTERNET],
                    failed: false,
                    success: false,
                    loading: true,
                }
            }
        }
        console.log("initial set ", flag, "flag ", from, { initSet })
        dispatch(setPrejoinDeviceMessages(initSet, flag))
    }

    const moveWithoutDevice = () => {
        let initSet = {
            show: true,
            messages: {
                [DEVICE_INFO_MESSAGES_KEYS.CHECK_DEVICE_INTERNET]: {
                    ...DEVICE_INFO_MESSAGES[DEVICE_INFO_MESSAGES_KEYS.CHECK_DEVICE_INTERNET],
                    loading: false,
                    success: false,
                    failed: true
                }
            }
        }
        dispatch(setPrejoinDeviceMessages(initSet))
        handleOnClose(systemBootMessage.SUBSCRIPTION_SHOW_BASIC)
    }

    const getFirstErrorInfoCode = (info_codes: array, default_code = null) => {

        let return_code = default_code
        if (info_codes.length) {
            if (info_codes.indexOf(INFO_CODE.SYMMETRIC_NAT) != -1) {
                return INFO_CODE.SYMMETRIC_NAT
            } else if (info_codes.indexOf(INFO_CODE.NO_INTER) != -1) {
                return INFO_CODE.NO_INTER;
            } else {
                return info_codes[0]
            }
        }

        return return_code
    }
    const getStatus = async (type, from = null) => {
        console.log("set my flag ", type, "from ", from)
        // reset socket event trigger
        dispatch(setPrejoinDeviceConnection(prejoinDetectDeviceEmitter.ERASE))
        setFlagType(type)
        // console.log("ssssssssssssssssssssssssss => ", type)

        if (type == STATUS_FLAG.AUDIO) {
            if (!props?.hideAudio) {
                setShowAudio(true)
            }
        } else if (type == STATUS_FLAG.VIDEO) {
            setShowVideo(true)
            setInit(false)
            if (sessionStorage.getItem("userWebcamDenied")) {
                // console.log("=> if case ")
                setTimeout(function () {
                    getStatus(STATUS_FLAG.DETECT_DEVICE, 1)
                }, 1000)
            } else {
                // initCheckDevice(DEVICE_INFO_MESSAGES_KEYS.CHECK_DEVICE_INTERNET)
                setTimeout(function () {
                    let allSta = getStore(FEATURE_CUSTOM_REDUX_V2);
                    console.log("=> else  case ", allSta.prejoinScreenDetail.isSet, "my data", allSta.browserDeviceStatus.video.status)
                    if (!allSta.prejoinScreenDetail.isSet && allSta.browserDeviceStatus.video.status) {
                        getStatus(STATUS_FLAG.DETECT_DEVICE, 2)
                    }
                }, 3000)
            }
        } else if (type == STATUS_FLAG.DETECT_DEVICE) {
            dispatch(getMySubscription(null, 3));
            let { conferenceJoined } = getStore(FEATURE_CUSTOM_REDUX);
            let setTime = Math.round(new Date().getTime() / 1000);

            let getAllSTate_v3 = getStore(FEATURE_CUSTOM_REDUX_V3);
            if (!conferenceJoined && (getAllSTate_v3.prejoinSubscription.show_basic || getAllSTate_v3.prejoinSubscription.show_premium)) {
                console.log("all was set but still it tried to execute")
                return false;
            }
            let hasPrev = false;
            if (sessionStorage.getItem("detect_dv_" + CURRENT_ROOM_NAME)) {
                if (calculateTimeDiff(sessionStorage.getItem("detect_dv_" + CURRENT_ROOM_NAME), 5)) {
                    return false;
                }
            }
            sessionStorage.setItem("detect_dv_" + CURRENT_ROOM_NAME, setTime)

            if (getBaseConfig("noDevicePreJoiningScreen") && !conferenceJoined) {
                handleOnClose(systemBootMessage.SUBSCRIPTION_SHOW_BASIC);
                return false;
            }

            let getAllSTate = getStore(FEATURE_CUSTOM_REDUX_V2);


            console.log("device detect request ", getAllSTate, "getAllSTate_v3", getAllSTate_v3)
            if (!getAllSTate.isUserDeviceDetecting) {
                setDeviceStatus({
                    ...deviceStatus,
                    infoCode: "",
                    willShow: true,
                    isDetecting: true
                })
                // setDeviceStepsWaiting(INFO_CODE.NO_DEVICE_DETECT, true, false, "device detect message");
                dispatch(setPrejoinDeviceMessages({
                    show: false,
                    messages: {}
                }, "device recheck"))

                if (getAllSTate_v3.prejoinScreenUserRoute == InvitedUserConfirmFlag.WITHOUT_DEVICE) {
                    // user want to go without device
                    // setDeviceStepsWaiting(INFO_CODE.NO_DEVICE_DETECT, true, true, "User go without device");
                    moveWithoutDevice()

                } else {

                    initCheckDevice(DEVICE_INFO_MESSAGES_KEYS.CHECK_DEVICE_INTERNET)
                    console.log("device detecting with flow")
                    try {
                        window.isPreJoinChecking = true;

                        let publicIp = await getPublicIp();
                        setDeviceIp(publicIp);
                        var message = {
                            action: {
                                publicIp: publicIp,
                                userId: props.userLoginData?.user?.id || null
                            },
                            content: 'device-list',
                            isBroadcast: true,
                            sender: 'mobile',
                            scope: "prejoin-a"
                        }

                        //-------------Prepare logger data -------------
                        var log_data = {
                            functionName: '',
                            triggeredBy: 'system',
                            event: message.content,
                            requestData: message,
                            responseData: '',
                            userId: '',
                            boxId: '',
                            message: 'Emit to server'
                        }
                        SaveLog(log_data);
                        //-------------------------------------------

                        sendData(message);
                        dispatch(setUserDeviceDetecting(true))

                        setTimeout(function () {
                            dispatch(setUserDeviceDetecting(false))
                            console.log("device detect deleted ")
                        }, 20000)
                    } catch (e) {
                        console.log("Unable to detect Ip address")
                    }
                    // if no any device detected then flow will not enter in devices length and user will stuck on detected device screen
                    setTimeout(function () {
                        let addState = getStore(FEATURE_CUSTOM_REDUX)
                        let addState_v2 = getStore(FEATURE_CUSTOM_REDUX_V2)

                        console.log("box detect timeout ", addState_v2.prejoinScreenDetail, "addState_v2", addState.prejoinDeviceCode)

                        if (!addState_v2.prejoinScreenDetail.isSet && (addState?.prejoinDeviceCode == "")) {
                            console.log("device is now  not pairing")
                            setTimeout(function () {
                                dispatch(setDetectDeviceTimer(""));
                            }, 5000)
                            dispatch(setDetectDeviceTimer("timeout"));
                        }
                    }, 10000)
                }
            }
        }
    }

    const fetchMyStaticDevice = () => {
        let _path = CURRENT_ROOM_NAME;

        let staticDv = null;
        if (_path.length > 2) {
            if (_path.indexOf("-") != -1) {
                let splt = _path.split("-");
                if (splt.length > 2) {
                    if (splt[1] == "device") {
                        staticDv = splt[2].toUpperCase();
                        setMyStaticDevice(staticDv)
                    }
                }
            }
        }

        // console.log("My device id", getQueryString("device_id"))
        if (getQueryString("device_id")) {
            let stdId = getQueryString("device_id");
            if (stdId.length == 6) {
                stdId = stdId.toUpperCase();
                staticDv = stdId;
                setMyStaticDevice(staticDv)
            }
        }

        if (!staticDv) {
            if (props.userBoxStaticDeviceId) {
                staticDv = props.userBoxStaticDeviceId;
                setMyStaticDevice(props.userBoxStaticDeviceId)
            }
        }
        // console.log("My device id 2", staticDv)

        return staticDv
    }

    useEffect(() => {

        fetchMyStaticDevice()
        dispatch(getMySubscription());

        setTimeout(function () {
            dispatch(getMySubscription());
        }, 5000)

        dispatch(getUserBox({
            activeDevice: true
        }));

        getDeviceMessage({
            info_code: [
                INFO_CODE.NO_DEVICE_DETECT,
                INFO_CODE.R_VD_N_ALD,
                INFO_CODE.R_AD_N_ALD,
                INFO_CODE.R_NET_SPEED,
            ]
        }).then((res) => {
            if (res.status == 1) {
                let messageData = {}
                try {
                    res.data.map(e => {
                        messageData[e.info_code] = e;
                    })

                    if (Object.keys(messageData).length) {
                        setInfoMessageView(messageData)
                    }
                } catch (e) {

                }
            }
        })

        const {
            hideVideo = false,
            hideInit
        } = props;
        setTimeout(function () {
            if (hideInit) {
                setInit(false)
            }
            getStatus(!hideVideo ? STATUS_FLAG.VIDEO : STATUS_FLAG.DETECT_DEVICE)
        }, 5000)

        socketOn("box-device-status", async data => {
            let publicIp = await getPublicIp();

            let allStats = getStore(FEATURE_CUSTOM_REDUX);
            let allStatsV2 = getStore(FEATURE_CUSTOM_REDUX_V2);
            let allStatsV3 = getStore(FEATURE_CUSTOM_REDUX_V3);

            // console.log("I have socket received ", data, publicIp)
            // console.log("socket received pre ", allStatsV2, "data", data)

            let myStatusId = fetchMyStaticDevice();
            if (!myStatusId) {
                myStatusId = myStaticDevice;
            }
            if (!myStaticDevice) {
                if (allStatsV3.userBoxStaticDeviceId) {
                    myStatusId = allStatsV3.userBoxStaticDeviceId
                }
            }

            let willBeMove = false;
            let willMakeEmpty = false;
            let prevDeviceConnected = false
            if (allStats.usersData != undefined) {
                if (allStats.usersData.uniqueId == data.device_id) {
                    // console.log("premeeting 1")
                    if (data.device_id) {
                        willBeMove = true;
                        willMakeEmpty = true;
                        // if current room is ip and having port issue then stop here, don't move and don't show the error
                        if (_ValidateIPaddress(CURRENT_ROOM_NAME)) {
                            if (data?.info_code?.indexOf(INFO_CODE.SYMMETRIC_NAT) != -1) {
                                return false;
                            }
                        }
                        setShowAudio(false)
                        getStatus(STATUS_FLAG.DETECT_DEVICE, 4);
                        prevDeviceConnected = true
                    }
                }
            } else {
                if (allStats.usersData == undefined) {
                    willBeMove = true;
                    // console.log("premeeting 2")
                    if (!myStatusId) {
                        let availDevs = await getAvailableDevice();
                        // console.log("availDevs 2", availDevs)
                        if (availDevs.availableDevice.length > 1) {
                            setShowMultiDevice(true);
                            willBeMove = false
                        }
                    }
                }
            }

            // console.log("socket received pre B  ", allStatsV2, "data", data, { willBeMove }, "myStaticDevice", myStaticDevice, "myStatusId", myStatusId)

            if ((data.device_ip == publicIp || allStatsV2.availableUserIp.indexOf(data.device_ip) != -1) && willBeMove) {
                // if user is on device screen(detecting, pairing, etc)
                // console.log("flag type is  ", allStatsV2.prejoinStepFlag)

                if (allStatsV2.prejoinStepFlag && allStatsV2.prejoinStepFlag != STATUS_FLAG.VIDEO) {

                    dispatch(getUserBox());
                    // console.log("socket received ", data);
                    if (data.info_code.length) {
                        // console.log("my device ", myStatusId, "other id ", allStats.uniqueId, "received id ", data.device_id, "myStaticDevice ", myStaticDevice)
                        let willRecheck = true;
                        if (myStatusId || allStats.uniqueId) {
                            if (myStatusId == data.device_id) {
                                willRecheck = true
                            } else if (allStats.uniqueId == data.device_id) {
                                willRecheck = true
                            } else {
                                willRecheck = false
                            }
                        }

                        if (myStatusId) {
                            if (data.device_id != myStatusId) {
                                return false;
                            }
                        }

                        if (!myStatusId) {
                            let availDevs = await getAvailableDevice();
                            if (availDevs.availableDevice.length > 1) {
                                setShowMultiDevice(true);
                                return false;
                                willRecheck = false;
                            }
                        }

                        // show error without recheck system

                        // console.log("will move  when socket received level 1", willRecheck, "myStatusId", myStatusId, "usersData", allStats.usersData)
                        if (willRecheck) { // if i have static device id attached on url /  no device id attached, if url has device id then it will strictly check

                            // console.log("socket will enter");

                            let store_v3 = getStore(FEATURE_CUSTOM_REDUX_V3)
                            let lastInfoCode = store_v3.lastPrejoinInfoCode;

                            let _allMessages = data.messages;

                            let _saveData = {}
                            _allMessages.map(e => {
                                _saveData[e.info_code] = e;
                            })

                            let _showPay = {
                                willShow: true,
                                isDetecting: false,
                                devicePairing: false,
                                devicePaired: false,
                                isDetectingFailed: true,
                                connectFailed: false,
                                infoCode: INFO_CODE.NO_DEVICE_DETECT
                            }

                            if (data?.info_code.length) {
                                // _showPay.infoCode = data?.info_code[0];
                                _showPay.infoCode = getFirstErrorInfoCode(data?.info_code, _showPay.infoCode)
                            }
                            // console.log("deviceStatus => ", deviceStatus, { data }, { _showPay })

                            if (_ValidateIPaddress(CURRENT_ROOM_NAME)) {
                                if (_showPay.infoCode == INFO_CODE.SYMMETRIC_NAT) {
                                    // if current room is ip and having port issue then stop here, don't move and don't show the error
                                    return false;
                                }
                            }

                            // console.log("after first check pass", { allStatsV2 }, { store_v3 })

                            if (_showPay.infoCode != INFO_CODE.NO_DEVICE_DETECT) {
                                // console.log("=> float 111 A", _showPay.infoCode, "prevDeviceConnected", prevDeviceConnected)
                                if (prevDeviceConnected) {
                                    dispatch(setDeviceInfoMessage({
                                        show: false,
                                        messages: []
                                    }, 123))
                                }
                                if (deviceStatus.infoCode == "") {
                                    if (!prevDeviceConnected) {
                                        let moveOn = true;
                                        // console.log("JKY 1", store_v3.prejoinDeviceMessages.messages)
                                        if (!store_v3.prejoinDeviceMessages.messages.hasOwnProperty(DEVICE_INFO_MESSAGES_KEYS.CHECK_INTERFACE)) {
                                            // console.log("JKY 2")

                                            if (_showPay.infoCode == INFO_CODE.NO_INTER) {
                                                // console.log("JKY 3")

                                                moveOn = false;
                                            }
                                        }
                                        if (moveOn) {
                                            handleInfoClick(_showPay.infoCode)
                                        }
                                    }
                                } else if (deviceStatus.infoCode != _showPay.infoCode) {
                                    // console.log("=> float 111 B ", _showPay.infoCode)
                                    dispatch(setDeviceInfoMessage({
                                        show: false,
                                        messages: []
                                    }, 1))
                                } else {
                                    // console.log("=> float 111 C ", _showPay.infoCode)
                                    handleInfoClick(_showPay.infoCode)
                                }
                                // setTimeout(function () {
                                //     handleInfoClick(_showPay.infoCode)
                                // }, 500)

                                setInfoMessageView({
                                    ...infoMessagesView,
                                    ..._saveData
                                })

                                dispatch(setPrejoinScreenDetail({
                                    isSet: false,
                                    roomname: "",
                                    uniqueId: "",
                                    scope: "new socket received with error"
                                }));


                                // if user has already interface error then stop here, or user has already port issue stop here

                                let setType = "socket received error";

                                if (_showPay.infoCode == INFO_CODE.NO_INTER) {
                                    setType = RUNNING_PROCESS_TIGGER_POINT.INTERFACE_ERROR
                                } else if (_showPay.infoCode == INFO_CODE.SYMMETRIC_NAT) { // port error
                                    setType = RUNNING_PROCESS_TIGGER_POINT.PORT_ERROR
                                } else if (_showPay.infoCode == INFO_CODE.NO_DEVICE_DETECT) {
                                    setType = RUNNING_PROCESS_TIGGER_POINT.NO_DEVICE_DETECT
                                }

                                let willProcess = true;
                                // console.log("socket type received ", _showPay.infoCode, "set type ", setType, "existing ", allStatsV3.prejoinDeviceStepsRunning, " flag", allStatsV3.prejoinDeviceStepsRunningFlag)
                                if (allStatsV3.prejoinDeviceStepsRunning == true) {
                                    if (allStatsV3.prejoinDeviceStepsRunningFlag == setType) {
                                        willProcess = false
                                    }
                                }

                                // console.log("Im will move ", willProcess);

                                if (willProcess) {

                                    dispatch(setPrejoinDeviceStepRunning(false));

                                    let moveFast = true;
                                    console.log("check pp 1", store_v3.prejoinDeviceMessages)
                                    if (store_v3.prejoinDeviceMessages.show) {
                                        if (Object.keys(store_v3.prejoinDeviceMessages.messages).length == 1) {
                                            moveFast = false
                                            dispatch(setPrejoinDeviceMessages({
                                                show: true,
                                                messages: {}
                                            }, "socket has error empty"))
                                        }
                                    }

                                    if (willMakeEmpty) {
                                        dispatch(setPrejoinDeviceMessages({
                                            show: true,
                                            messages: {}
                                        }, "socket has error empty device was connected"));
                                        setRecheckingDevice(true)
                                        setTimeout(() => {
                                            setRecheckingDevice(false)
                                        }, 10000);
                                    }

                                    setTimeout(function () {
                                        setDeviceStepsWaiting(_showPay.infoCode, true, false, setType, "socket with error")
                                    }, 100)
                                    // updateSocketMessage(_showPay.infoCode)

                                    setDeviceStatus(_showPay)
                                }
                            }
                        }
                        // }
                        // }

                    } else {
                        // not having any error
                        let _showPayA = {
                            willShow: true,
                            isDetecting: true,
                            devicePairing: false,
                            devicePaired: false,
                            isDetectingFailed: false,
                            connectFailed: false,
                            infoCode: INFO_CODE.WAITING_DEVICE
                        }

                        let _willRecheck = true;
                        if (myStatusId || allStats.uniqueId) {
                            if (myStatusId == data.device_id) {
                                _willRecheck = true
                            } else if (allStats.uniqueId == data.device_id) {
                                _willRecheck = true
                            } else {
                                _willRecheck = false
                            }
                        }


                        // console.log("socket received without error", _showPayA)

                        if (!myStatusId) {
                            let availDevs = await getAvailableDevice();
                            if (availDevs.availableDevice.length > 1) {
                                setShowMultiDevice(true)
                                _willRecheck = false;
                            }
                        }

                        // if user has already interface error then stop here, or user has already port issue stop here

                        let _setType = "socket received error";

                        if (_showPayA.infoCode == INFO_CODE.NO_INTER) {
                            // console.log(" going in step A")
                            _setType = RUNNING_PROCESS_TIGGER_POINT.INTERFACE_ERROR
                        } else if (_showPayA.infoCode == INFO_CODE.SYMMETRIC_NAT) { // port error
                            // console.log(" going in step B")
                            _setType = RUNNING_PROCESS_TIGGER_POINT.PORT_ERROR
                        } else if (_showPayA.infoCode == INFO_CODE.NO_DEVICE_DETECT) {
                            // console.log(" going in step C")
                            _setType = RUNNING_PROCESS_TIGGER_POINT.NO_DEVICE_DETECT
                        } else if (_showPayA.infoCode == INFO_CODE.WAITING_DEVICE) {
                            // console.log(" going in step D", _showPayA);
                            _setType = RUNNING_PROCESS_TIGGER_POINT.DEVICE_NOT_ERROR_WAITING

                        }

                        // console.log("socket type received no error  ", _showPayA.infoCode, "set type ", _setType, "existing ", allStatsV3.prejoinDeviceStepsRunning, " flag", allStatsV3.prejoinDeviceStepsRunningFlag, "is rechecking ", isRecheckingDevice)

                        if (allStatsV3.prejoinDeviceStepsRunning == true) {
                            if (allStatsV3.prejoinDeviceStepsRunningFlag == _setType) {
                                _willRecheck = false
                            }
                        }

                        // console.log("socket has not error i'll move ", _willRecheck)


                        if (_willRecheck) {

                            dispatch(setDeviceInfoMessage({
                                show: false,
                                messages: []
                            }, 2))

                            // console.log("socket received without error inside", _showPayA)
                            setDeviceStatus(_showPayA)
                            // dispatch(setPrejoinDeviceMessages({
                            //     show: true,
                            //     messages: {}
                            // }))


                            dispatch(setPrejoinScreenDetail({
                                isSet: false,
                                roomname: "",
                                uniqueId: "",
                                scope: "new socket received without error"
                            }));

                            dispatch(setPrejoinDeviceMessages({
                                show: true,
                                messages: {}
                            }, "socket has no error empty"))
                            setRecheckingDevice(true)
                            setTimeout(() => {
                                setRecheckingDevice(false)
                            }, 10000);
                            dispatch(setPrejoinDeviceStepRunning(false));

                            // setTimeout(function () {
                            //     initCheckDevice(DEVICE_INFO_MESSAGES_KEYS.CHECK_DEVICE_INTERNET, "socket got without error")
                            // }, 500)

                            setTimeout(function () {
                                // setTimeout(function () {
                                setDeviceStepsWaiting(INFO_CODE.WAITING_DEVICE, false, false, RUNNING_PROCESS_TIGGER_POINT.DEVICE_NOT_ERROR_WAITING, "socket received without error")
                            }, 100)
                            // }, 1000)
                            // detect if even after one min the device is not detected, show default error
                            try {
                                let timer = setTimeout(function () {
                                    let allState = getStore(FEATURE_CUSTOM_REDUX)
                                    let allState_v2 = getStore(FEATURE_CUSTOM_REDUX_V2)

                                    // console.log(" no any device detected after socket a", allState.usersData, "prejoinDeviceCode", allState_v2.prejoinDeviceCode)

                                    // console.log("device error free timeout a")
                                    if ((allState.usersData == undefined || allState.usersData == null) && !allState_v2.prejoinScreenDetail.isSet) {
                                        // console.log("device error free timeout b")

                                        // console.log("no any device detected after socket b", allState.usersData)
                                        setDeviceStatus({
                                            willShow: true,
                                            isDetecting: false,
                                            devicePairing: false,
                                            devicePaired: false,
                                            isDetectingFailed: true,
                                            connectFailed: false,
                                            infoCode: INFO_CODE.NO_DEVICE_DETECT
                                        })
                                        // dispatch(setDeviceInfoMessage({
                                        //     show: true,
                                        //     messages: [],
                                        //     info_code: INFO_CODE.NO_DEVICE_DETECT
                                        // }));
                                        setDeviceStepsWaiting(INFO_CODE.UNKNOWN_ERROR)
                                    }
                                }, WAITING_TIME.FINAL_WAITING * 1000)

                                // dispatch(setDeviceInfoMessage({
                                //     show: false,
                                //     messages: []
                                // }));

                                setTimeout(function () {
                                    // console.log("will show waiting mod")

                                    dispatch(setDeviceInfoMessage({
                                        show: false,
                                        messages: []
                                    }, 3));

                                    // setTimeout(function () {
                                    //     dispatch(setDeviceInfoMessage({
                                    //         show: true,
                                    //         messages: [],
                                    //         info_code: INFO_CODE.WAITING_DEVICE
                                    //     }));
                                    // }, 100)

                                    dispatch(setPrejoinSocketDWaiting(true));

                                    setTimeout(function () {
                                        // console.log("device not received till now")
                                        dispatch(setPrejoinSocketDWaiting(false));
                                    }, WAITING_TIME.SOCKET_WAIT_EXPIRE)

                                    setDeviceStatus({
                                        willShow: true,
                                        isDetecting: true,
                                        devicePairing: false,
                                        devicePaired: false,
                                        isDetectingFailed: false,
                                        connectFailed: false,
                                        infoCode: INFO_CODE.WAITING_DEVICE
                                    })
                                    // setDeviceStepsWaiting(_showPayA.infoCode)
                                    // setDeviceStepsStatus(INFO_CODE.WAITING_DEVICE, true, "socket received waiting instant")
                                }, 500)
                            } catch (e) {
                                console.log("socket error detected")
                            }
                        }
                    }
                }
            }
        })
        setTimeout(function () {
            if (!props.hideVideo && !props.hideVideo) {
                dispatch(setAudioMuted(false));
                dispatch(muteLocal(false, MEDIA_TYPE.AUDIO))
                dispatch(setVideoMuted(false));
                dispatch(setVideoMuted(false, "video", VIDEO_MUTISM_AUTHORITY.USER, true));
            }
        }, 2000)
        // dispatch(getMySubscription())
        return () => {
            if (document.getElementById("launcher")) {
                let { showDevicePreConnection } = getStore(FEATURE_CUSTOM_REDUX_V3);
                if (getBaseConfig("showPreJoiningInConference") && showDevicePreConnection) {
                    document.getElementById("launcher").style.display = '';
                } else {
                    document.getElementById("launcher").style.display = 'none';
                }
                delete window.isPreJoinChecking;
            }
        }
    }, [])


    let prevPrejoinInit = usePrevious(prejoinDeviceConnection);

    // start the reinit the process of system checking

    let prevDeviceList = usePrevious(deviceList);

    const reCheckSystem = (show_modal = false) => {

        if (show_modal) {
            setRecheckingDevice(true)
            setTimeout(function () {
                setRecheckingDevice(false)
            }, 10000)
        }

        dispatch(setPrejoinSocketDWaiting(false));

        dispatch(setDeviceInfoMessage({
            show: false,
            messages: []
        }, 5));

        dispatch(setPrejoinDeviceMessages({
            show: false,
            messages: {}
        }, "recheck system"))

        dispatch(setPrejoinScreenDetail({
            isSet: false,
            roomname: "",
            uniqueId: "",
            scope: "user move with flow"
        }))

        dispatch(setDetectDeviceTimer(""));
        dispatch(setPrejoinDeviceStepRunning(false))

        console.log("devicesss process ")
        setInit(true)
        setShowAudio(false)

        setShowVideo(false)

        setDeviceStatus({
            willShow: false,
            isDetecting: false,
            devicePairing: false,
            devicePaired: false,
            isDetectingFailed: false,
            connectFailed: false,
            infoCode: ""
        })

        setTimeout(function () {
            dispatch(setPrejoinDeviceConnection(""))
            // if (!sessionStorage.getItem("userWebcamDenied")) {
            getStatus(STATUS_FLAG.VIDEO)
            // console.log(" detecting device a")

            // }
        }, 3000)

        setTimeout(function () {
            // console.log(" detecting device b")

            let allSts = getStore(FEATURE_CUSTOM_REDUX_V2)
            // console.log(" detecting device b 2", allSts)
            if (!allSts.isUserDeviceDetecting) {
                // console.log(" detecting device c")
                getStatus(STATUS_FLAG.DETECT_DEVICE, 5)
            }
        }, 8000)
    }

    useEffect(() => {
        // the devices received from socket should be present on devices list(device with issue table)
        // show devices which are error free else show error
        // 
        if (prevPrejoinInit != prejoinDeviceConnection || deviceList?.length != prevDeviceList?.length) {
            // re init if device has changed
            if (flagType == STATUS_FLAG.DETECT_DEVICE && prevPrejoinInit == prejoinDetectDeviceEmitter.SOC_RECEIVED) {
                // setFlagType("")
            }

            if (prevPrejoinInit == prejoinDetectDeviceEmitter.SOC_RECEIVED
                && prejoinDeviceConnection == prejoinDetectDeviceEmitter.DV_RECEIVED) {
                // reCheckSystem()
            }
        }
    }, [prejoinDeviceConnection, deviceList])

    let oldPrejoinDeviceConnectTime = usePrevious(props.prejoinDeviceConnectTime);

    useEffect(() => {
        if (props.prejoinDeviceConnectTime == 1) {
            setTryingToReconnect(1);
            setTimeout(() => {
                setTryingToReconnect(0);
            }, 10000)
        } else if (props.prejoinDeviceConnectTime == 2) {
            setTryingToReconnect(2);
            setTimeout(() => {
                setTryingToReconnect(0);
            }, 10000)
        }
    }, [props.prejoinDeviceConnectTime])


    const pairDevice = (deviceId) => {
        let allData = getStore(FEATURE_CUSTOM_REDUX_V2);
        let store_v1 = getStore(FEATURE_CUSTOM_REDUX);

        console.log("conference connected prejoin ", store_v1.conferenceJoined)

        let canDeviceJoin = !store_v1.conferenceJoined;

        if (props?.joinWithConference) {
            canDeviceJoin = true
        }

        if (!prejoinScreenDetail.isSet && canDeviceJoin) {

            setDeviceId(deviceId)
            localStorage.setItem("uniqueID", deviceId);
            let tempRoom;

            // tempRoom = randomString();
            tempRoom = TEMP_ROOM
            window.connectionReq = tempRoom;

            dispatch(setPrejoinScreenDetail({
                isSet: true,
                roomname: tempRoom,
                uniqueId: deviceId,
                scope: "prejoin"
            }))

            dispatch(setDeviceInfoMessage({
                show: false,
                messages: []
            }, 6));

            setConnectRequested(true)

            if (tempRoom) {
                const obj = {
                    uniqueId: deviceId,
                    room: tempRoom
                }
                dispatch(setData(obj))

                let message = {
                    action: {
                        uniqueID: deviceId,
                        ipAddress: tempRoom,
                        protocolId,
                    },
                    content: 'unique_check',
                    isBroadcast: true,
                    sender: 'mobile',
                    scope: 'pre-joining'
                };
                sendData(message);
                //-------------Prepare logger data -------------
                var log_data = {
                    functionName: '',
                    triggeredBy: 'system',
                    event: message.content,
                    requestData: message,
                    responseData: '',
                    userId: '',
                    boxId: message.action.uniqueID,
                    message: 'Emit to server'
                }
                SaveLog(log_data);
                //-------------------------------------------
            }

            setTimeout(async function () {
                let getAllSt = getStore(FEATURE_CUSTOM_REDUX);

                let all_store_v2 = getStore(FEATURE_CUSTOM_REDUX_V2)
                console.log("device connect timeout ", all_store_v2.prejoinScreenDetail, "device data ", getAllSt.usersData)

                let canDeviceJoin = !getAllSt.conferenceJoined
                if (props?.joinWithConference) {
                    canDeviceJoin = true
                }
                console.log("Connect timeout A", canDeviceJoin)
                // if (getAllSt.conferenceJoined == false) {
                if (canDeviceJoin) {
                    console.log("Connect timeout B", canDeviceJoin)

                    if ((getAllSt.usersData == null || getAllSt.usersData == undefined) && all_store_v2.prejoinScreenDetail.isSet) {
                        dispatch(setPrejoinScreenDetail({
                            isSet: false,
                            roomname: "",
                            uniqueId: "",
                            scope: "failed-connect-timeout"
                        }));

                        // check if user has box but unable to connect with box
                        // reboot box or get status from db

                        let roomStatus = await getDeviceStatus({
                            device_ip: getDeviceIp,
                            device_id: getAllSt.uniqueId
                        });

                        let showPay = {
                            // ...deviceStatus,
                            willShow: true,
                            isDetecting: false,
                            devicePairing: false,
                            devicePaired: false,
                            isDetectingFailed: false,
                            connectFailed: true,
                            infoCode: INFO_CODE.UNKNOWN_ERROR_CONNECT
                        }

                        let willShowDBError = false;

                        let hasDevice = false;
                        if (roomStatus.availableDevice != undefined) {
                            if (roomStatus.availableDevice.length) {
                                hasDevice = true;
                            }
                        }

                        if (roomStatus.status == 1) {
                            if (roomStatus.data?.info_code && roomStatus.data?.info_code != "") {
                                let allMessages = roomStatus.data.messages;

                                let saveData = {}
                                allMessages.map(e => {
                                    saveData[e.info_code] = e;
                                })

                                if (roomStatus.data?.info_code?.length) {
                                    showPay.infoCode = getFirstErrorInfoCode(roomStatus.data?.info_code, showPay.infoCode)

                                    // showPay.infoCode = roomStatus.data?.info_code[0];
                                    willShowDBError = true
                                }

                                setInfoMessageView({
                                    ...infoMessagesView,
                                    ...saveData
                                })
                                // show modal if any error to user
                            }
                        }

                        // handleInfoClick(showPay.infoCode)

                        setDeviceStatus(showPay);

                        dispatch(setPrejoinDeviceStepRunning(false))
                        var log_data = {
                            functionName: '',
                            triggeredBy: 'automatic',
                            event: "trying-reconnect",
                            requestData: {
                                publicIp: getDeviceIp,
                                times: 1,
                                device_id: deviceId,
                                tempRoom: TEMP_ROOM,
                                visibleRoom: CURRENT_ROOM_NAME
                            },
                            responseData: '',
                            userId: props?.userLoginData?.user?.id,
                            boxId: deviceId,
                            message: 'Emit to server'
                        }

                        if (showPay.infoCode == INFO_CODE.UNKNOWN_ERROR_CONNECT) {
                            let store_v3 = getStore(FEATURE_CUSTOM_REDUX_V3)

                            console.log("connectFailedTime ", store_v3.prejoinDeviceConnectTime)
                            if (store_v3.prejoinDeviceConnectTime == 0) { // if failed at once
                                dispatch(setPrejoinDeviceConnectTime(1))
                                console.log("trying to reconnect with same device");

                                pairDevice(deviceId);

                                SaveLog(log_data);

                                return false;
                            } else if (store_v3.prejoinDeviceConnectTime == 1) { // if failed second time
                                dispatch(setPrejoinDeviceConnectTime(2))
                                console.log("Failed to connect with device second time");
                                log_data.requestData.times = 2;
                                SaveLog(log_data);

                                setTimeout(() => {
                                    if (getBaseConfig("showPreJoiningInConference")) {
                                        dispatch(setDeviceContainerStatus("closeWebjamMixer", "pre-meeting cancel"))
                                        dispatch(setEnableWebjamModal(false));
                                        dispatch(setPrejoinDeviceConnectTime(0))
                                        dispatch(setPrejoinDeviceStepRunning(false))
                                        dispatch(setPrejoinScreenDetail({
                                            isSet: false,
                                            roomname: "",
                                            uniqueId: "",
                                            scope: "preconnection user cancel"
                                        }))
                                        dispatch(setShowDevicePreConnection(false));
                                        dispatch(setPrejoinDeviceMessages({
                                            show: false,
                                            messages: {}
                                        }, "device init reset"))
                                        dispatch(setPrejoinSubscriptionUI({
                                            show_basic: false,
                                            basic_checking: "",
                                            show_premium: false
                                        }))
                                        dispatch(setPrejoinDevicePingCalculate(prejoinDeviceCalculateFlag.DEFAULT))
                                    } else {
                                        if (window.parent) {
                                            // if (window?.parent?.location?.search?.indexOf("device_id") != -1) {
                                            //     window.parent.location.href = window.parent.location.reload();
                                            // } else {
                                            //     window.parent.location.href = window.parent.location.href + "?device_id=" + deviceId;
                                            // }
                                            window.location.reload()
                                        } else {
                                            window.location.reload()
                                            // if (window.location?.search?.indexOf("device_id")) {
                                            //     window.location.href = window.location.reload();
                                            // } else {
                                            //     window.location.href = window.location.href + "?device_id=" + deviceId;
                                            // }
                                        }
                                    }
                                }, 7000)
                                return false;
                            }
                        }

                        setTimeout(function () {
                            // if device is active and has other error in db then stop steps at exact error
                            if (hasDevice && showPay.infoCode != INFO_CODE.NO_DEVICE_DETECT) {
                                setDeviceStepsStatus(showPay.infoCode, false, "detect-timeout")
                            } else {
                                // stop at internet check first step
                                setDeviceStepsWaiting(INFO_CODE.NO_DEVICE_DETECT, true, false, "device is not available")
                            }
                        }, 1000)

                        console.log("=> default error will not show A", willShowDBError)
                    }
                }
            }, WAITING_TIME.CONNECT_EXPIRE * 1000)
        }
    }

    const checkUserSubsFn = (showFailed, premium_required = false) => {
        let prejoinDeviceMessages = props.prejoinDeviceMessages;
        // checking

        let updatedMessages = {
            ...prejoinDeviceMessages.messages,
            [DEVICE_INFO_MESSAGES_KEYS.CHECK_SUBSCRIPTION]: {
                ...DEVICE_INFO_MESSAGES[DEVICE_INFO_MESSAGES_KEYS.CHECK_SUBSCRIPTION],
                failed: false,
                success: false,
                loading: true
            }
        }

        console.log("User box connected ", updatedMessages, prejoinDeviceMessages, "users data ", usersData)
        if (updatedMessages.hasOwnProperty(DEVICE_INFO_MESSAGES_KEYS.CHECK_COMPATIBLE)) {

            dispatch(setPrejoinDeviceMessages({
                show: true,
                messages: updatedMessages
            }))
        }

        setTimeout(function () {
            let showModal = true;
            let updates = { ...updatedMessages };
            if (updates.hasOwnProperty(DEVICE_INFO_MESSAGES_KEYS.CHECK_COMPATIBLE)) {


                if (showFailed) {

                    updates[DEVICE_INFO_MESSAGES_KEYS.CHECK_SUBSCRIPTION].loading = false
                    updates[DEVICE_INFO_MESSAGES_KEYS.CHECK_SUBSCRIPTION].failed = true
                } else {
                    updates[DEVICE_INFO_MESSAGES_KEYS.CHECK_SUBSCRIPTION].loading = false
                    updates[DEVICE_INFO_MESSAGES_KEYS.CHECK_SUBSCRIPTION].success = true
                    showModal = false;
                }
                console.log("=> i will updated ", updates, "usersData", usersData)

                dispatch(setPrejoinDeviceMessages({
                    show: true,
                    messages: updates
                }))

                if (showModal) {
                    handleInfoClick(updates[DEVICE_INFO_MESSAGES_KEYS.CHECK_SUBSCRIPTION].infoCode)
                }

                console.log("showFailed ", showFailed)

                if (showFailed) {

                } else {
                    _showAllSet(1)
                }
            }
        }, 2000)
    }

    const _showAllSet = (from = null) => {
        let store_v2 = getStore(FEATURE_CUSTOM_REDUX_V2)

        let {
            prejoinDevicePingCalculation
        } = props;

        let showAllSet = false;

        if (store_v2.browserDeviceStatus.audio.infoCode == "" || store_v2.browserDeviceStatus.audio.infoCode == INFO_CODE.MICROPHONE_MUTED) {
            showAllSet = true;
        }

        // console.log("hideAudio ", props)
        if (!props?.hideAudio) {
            getStatus(STATUS_FLAG.AUDIO);
            if (store_v2.browserDeviceStatus.audio.infoCode != "") {
                setTimeout(() => {
                    handleInfoClick(store_v2.browserDeviceStatus.audio.infoCode)
                }, 100)
                return false
            }
        }

        if (props?.hideAudio) showAllSet = true;

        // if (props?.hideAudio) showAllSet = true

        console.log("showAllSet ", showAllSet, "ssssssss ", store_v2.joinRoomWithoutDevice)
        if (showAllSet) {
            if (prejoinDevicePingCalculation != prejoinDeviceCalculateFlag.WAITING) {
                if (!store_v2.joinRoomWithoutDevice) {
                    console.log("All set B")
                    dispatch(setJoinRoomWithoutDevice(true, 3))
                    // dispatch(setUserPrejoinAllSet(true))
                    let { uniqueId, conferenceJoined } = getStore(FEATURE_CUSTOM_REDUX)
                    if (getBaseConfig("showPreJoiningInConference") && conferenceJoined) {
                        // let now_time = Math.round(new Date().getTime() / 1000);
                        // sessionStorage.setItem("dv_cnf_tm", JSON.stringify({
                        //     time: now_time,
                        //     id: uniqueId
                        // }))
                    } else {

                        console.log("showAllSet ", showAllSet, "jjjjjjjjjjjjjjj ", props.joinRoomWithoutDevice)


                        dispatch(setDeviceInfoMessage({
                            show: true,
                            messages: [],
                            info_code: INFO_CODE.ALL_SET
                        }, 7))
                    }
                }
            }
        } else {
            if (browserDeviceStatus.audio.infoCode != "") {
                handleInfoClick(browserDeviceStatus.audio.infoCode)
            }
        }
    }

    let prevPrejoinDevicePingCalculation = usePrevious(props.prejoinDevicePingCalculation)
    useEffect(() => {
        // console.log("prejoinDevicePingCalculation 1 ", props.prejoinDevicePingCalculation, "prevPrejoinDevicePingCalculation ", prevPrejoinDevicePingCalculation)
        if (prevPrejoinDevicePingCalculation) {
            // console.log("prejoinDevicePingCalculation 2", props.prejoinDevicePingCalculation, "prevPrejoinDevicePingCalculation ", prevPrejoinDevicePingCalculation)
            if (prevPrejoinDevicePingCalculation == prejoinDeviceCalculateFlag.WAITING && props.prejoinDevicePingCalculation == prejoinDeviceCalculateFlag.RECEIVED) {
                // console.log("All seems set ")
                setTimeout(function () {
                    showUSubscription(true)
                }, 1000)
            }
        }
    }, [props.prejoinDevicePingCalculation])

    const willAskSubscription = () => {
        let curTime = Math.round(new Date().getTime() / 1000);
        let store_pay = getStore(FEATURE_CUSTOM_PAYMENT);
        // console.log("User subscription A", store_pay)
        let hasSubscription = false;
        if (store_pay.userPaymentSubscription.pack_id) {
            hasSubscription = true;
            if (store_pay.userPaymentSubscription.is_canceled == false) {
                if (store_pay.userPaymentSubscription.end_at < curTime) {
                    hasSubscription = false;
                } else {
                    hasSubscription = true;
                }
            } else {
                if (store_pay.userPaymentSubscription.is_canceled) {
                    if (store_pay.userPaymentSubscription.end_at > curTime) {
                        hasSubscription = true;
                    }
                } else {
                    hasSubscription = false;
                }
            }

            if (hasSubscription) {
                if (store_pay.userPaymentSubscription.is_expired) {
                    hasSubscription = false;
                }
            }
        }


        // console.log("User subscription B", hasSubscription)

        let return_data = {
            basic: false,
            premium: false
        }

        if (hasSubscription) {
            return_data.basic = true;
            if (store_pay.userPaymentSubscription.is_premium) {
                return_data.premium = true;
            }
        }
        // console.log("User subscription C", return_data)


        return return_data
    }


    const showUSubscription = (device_connected = false) => {
        let subscription = willAskSubscription();

        // console.log("i have received 1", subscription)

        // if (getBaseConfig("subscriptionRequired") == true) {
        // console.log("i have received 2")

        if (usersData != null || usersData != undefined) {
            // console.log("i have received 3")

            checkUserSubsFn(subscription.premium == false ? true : false, true)
        } else {
            // console.log("i have received 4")
            if (!subscription.premium || !subscription.basic) {
                // console.log("i have received 5")
                checkUserSubsFn(true, true)
            }
        }
        // console.log("i have received 7")
    }

    const detectAndJoinDevice = async (willMove = false, device_id = null) => {
        const { socketDeviceWaiting } = props;
        // console.log("box changed ", flagType, "prevDeviceList ", prevDeviceList, "deviceList", deviceList, "usersData", usersData, "detectDeviceTimer", detectDeviceTimer, deviceStatus, "socketDeviceWaiting", socketDeviceWaiting, "willMove", willMove, "device_id", device_id)
        // dispatch(setPrejoinSocketDWaiting(false));

        // if ((!socketDeviceWaiting && flagType == STATUS_FLAG.DETECT_DEVICE && prevDeviceList != deviceList && usersData == null) || detectDeviceTimer == "timeout" || willMove) {
        if ((flagType == STATUS_FLAG.DETECT_DEVICE && prevDeviceList != deviceList && usersData == null) || detectDeviceTimer == "timeout" || willMove) {
            let willProcess = true;

            let userSelDevice = myStaticDevice;
            if (willMove && device_id) {
                userSelDevice = device_id
            }

            if (prevDeviceList != deviceList) {
                if (userSelDevice) {
                    if (deviceList.indexOf(userSelDevice) == -1) {
                        willProcess = false;
                    }
                }
            }

            // console.log("=> pointer not moving ", willProcess, "cur device ", userSelDevice)

            if (willProcess) {
                // console.log("will go inside")
                let willMove = false;
                let _deviceList = [...deviceList];
                // to check devices in different network
                let _allStore_v2 = getStore(FEATURE_CUSTOM_REDUX_V2);

                let _allStore = getStore(FEATURE_CUSTOM_REDUX);

                if (_allStore_v2.registeredDevice.length) {
                    if (!_deviceList.length) {
                        _deviceList = _allStore_v2.registeredDevice;
                    }
                }

                if (_deviceList.length) {
                    willMove = true;
                    if (userSelDevice) {
                        if (_deviceList.indexOf(userSelDevice) != -1) {
                            willMove = true;
                        } else {
                            willMove = false;
                        }
                    } else {
                        willMove = true
                    }
                } else {
                    willMove = false
                }

                let store_v3 = getStore(FEATURE_CUSTOM_REDUX_V3);

                // console.log("store v3 ", store_v3)

                if (store_v3.prejoinDeviceStepsRunning && store_v3.prejoinDeviceStepsRunningFlag == RUNNING_PROCESS_TIGGER_POINT.DEVICE_PAIRING) {
                    console.log("=>  process is already on going with  ", store_v3.prejoinDeviceStepsRunning, "ddddddddddddd", store_v3.prejoinDeviceStepsRunningFlag)
                    return false;

                }
                // console.log("=> will move a ", willMove)

                // if (deviceList.length && deviceList.indexOf("25D06A") != -1) {
                if (willMove) {
                    // console.log("=> will move b ", prejoinScreenDetail.isSet)

                    if (!prejoinScreenDetail.isSet) {
                        let pid = _deviceList[0];
                        if (userSelDevice) {
                            pid = userSelDevice;
                        }
                        console.log("I will set and pair with device ", pid)
                        dispatch(setUserStaticDeviceId(pid))
                        try {
                            let getIp = await getPublicIp()
                            let getDeviceStat = await getDeviceStatus({
                                device_ip: getIp,
                                device_id: pid
                            });

                            console.log("getDeviceStatus after connect ", getDeviceStat);

                            if (getDeviceStat.status == 1) {
                                let infoCodes = [];

                                if (getDeviceStat?.is_multiple) {
                                    let _user_ip_list = getDeviceStat.data.map(e => e.device_ip);
                                    dispatch(setAvilableUserIP(_user_ip_list))
                                }

                                if (getDeviceStat?.data?.info_code?.length) {
                                    infoCodes = getDeviceStat.data.info_code;
                                } else if (getDeviceStat?.data?.length) {
                                    let selDev = getDeviceStat?.data?.filter(e => e.device_id == pid);
                                    console.log("selDevselDev ", selDev)
                                    if (selDev && selDev.length) {
                                        infoCodes = selDev[0].info_code;
                                    }
                                }
                                console.log("infoCodes =>>>>>>>>>>>>>", infoCodes);

                                if (infoCodes?.length) {
                                    if (infoCodes?.indexOf(INFO_CODE.SYMMETRIC_NAT) != -1) {
                                        if (!_ValidateIPaddress(CURRENT_ROOM_NAME)) {
                                            setDeviceStepsWaiting(INFO_CODE.SYMMETRIC_NAT, true, false, "self host having port issue");
                                            return false;
                                        }
                                    }
                                }
                            }
                        } catch (e) {
                            console.log("Device connect but having error in true case ", e)
                        }



                        setDeviceStatus({
                            willShow: true,
                            isDetecting: false,
                            devicePairing: true,
                            devicePaired: false,
                            isDetectingFailed: false,
                            connectFailed: false
                        })

                        let deviceMessage = Object.keys(DEVICE_INFO_MESSAGES);
                        // dispatch(setPrejoinDeviceMessages({
                        //     show: true,
                        //     messages: {}
                        // }))

                        let willDevicePair = true;
                        let _allState_V3 = getStore(FEATURE_CUSTOM_REDUX_V3);
                        let _existingMessages = _allState_V3.prejoinDeviceMessages;
                        console.log("Im going to pair with devic ", { _allState_V3 }, { _existingMessages })
                        // check if user is already on interface compatibility check state, check length of objects (except subscription)
                        console.log("=> _existingMessages.messages ", _existingMessages.messages, "length", Object.keys(_existingMessages.messages).length, "deviceMessage", deviceMessage.length)
                        if (Object.keys(_existingMessages.messages).length == (deviceMessage.length - 1)) {

                            if (_allState_V3.prejoinDeviceStepsRunning == true && (_allState_V3.prejoinDeviceStepsRunningFlag == RUNNING_PROCESS_TIGGER_POINT.DEVICE_NOT_ERROR_WAITING || _allState_V3.prejoinDeviceStepsRunningFlag == RUNNING_PROCESS_TIGGER_POINT.NO_DEVICE_DETECT)) {
                                let lastKey = getLastKey(_existingMessages.messages);
                                console.log("las key ", lastKey)
                                if (lastKey == DEVICE_INFO_MESSAGES_KEYS.CHECK_COMPATIBLE) {
                                    pairDevice(pid)
                                    willDevicePair = false;
                                }
                            }
                        }

                        dispatch(setPrejoinDeviceStepRunning(true, RUNNING_PROCESS_TIGGER_POINT.DEVICE_PAIRING));

                        console.log("device will pair state ", willDevicePair, "with device ", pid)
                        if (willDevicePair) {
                            for (var i = 0; i < deviceMessage.length - 1; i++) { // subscription will be check once device is connected
                                // console.log("=> keys ", deviceMessage, deviceMessage[i])
                                let ke = deviceMessage[i];

                                let val = DEVICE_INFO_MESSAGES[ke];
                                (function (index) {
                                    setTimeout(function () {
                                        try {
                                            let _allStateV3 = getStore(FEATURE_CUSTOM_REDUX_V3);
                                            let existingVal = _allStateV3.prejoinDeviceMessages;

                                            // console.log("=> keys c", _allStateV3, deviceMessage, val, ke)

                                            let willMove = true;
                                            if (willMove) {
                                                // if user has removed device internet or remove any other accessories of device then stop the process
                                                if (_allStateV3.prejoinDeviceStepsRunning && _allStateV3.prejoinDeviceStepsRunningFlag == RUNNING_PROCESS_TIGGER_POINT.DEVICE_PAIRING) {
                                                    console.log("i'm going with process ")
                                                } else {
                                                    willMove = false;
                                                    console.log("It seems like your has removed some part of device ", _allStateV3.prejoinDeviceStepsRunning, "from", _allStateV3.prejoinDeviceStepsRunningFlag)
                                                }
                                            }

                                            if (willMove) {
                                                let allVal = {
                                                    show: true,
                                                    messages: {
                                                        ...existingVal.messages,
                                                        [ke]: { ...val, success: false, loading: true, failed: false }
                                                    }
                                                }
                                                dispatch(setPrejoinDeviceMessages(allVal))

                                                // console.log("before message update ", allVal, "key", ke, "existing ", existingVal.messages, "val", {
                                                //     loading: val.loading,
                                                //     success: val.success
                                                // }, "can be ", allVal.messages[ke])
                                                if (ke == DEVICE_INFO_MESSAGES_KEYS.CHECK_COMPATIBLE) {
                                                    if (_allStateV3.showDevicePreConnection || !_allStore.conferenceJoined) {
                                                        // console.log("hereeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee 1")
                                                        pairDevice(pid)
                                                    }
                                                } else {
                                                    setTimeout(function () {
                                                        if (_allStateV3.showDevicePreConnection || !_allStore.conferenceJoined) {
                                                            let updated = {
                                                                ...allVal
                                                            }
                                                            updated.messages[ke].loading = false;
                                                            updated.messages[ke].success = true;
                                                            dispatch(setPrejoinDeviceMessages(updated))
                                                        }
                                                    }, WAITING_TIME.DEVICE_PROGRESS_TIME_AFTER)
                                                }
                                            }
                                        } catch (e) {
                                            console.log("=> keys b", e)
                                        }
                                    }, i * WAITING_TIME.DEVICE_PROGRESS_TIME);

                                })(i);
                            }
                        }
                    }
                } else {

                    // setFlagType("");

                    let payld = {
                        device_ip: getDeviceIp
                    }

                    if (userSelDevice) {
                        payld = Object.assign({
                            device_id: userSelDevice
                        }, payld)
                    }

                    let roomStatusRes = await getDeviceStatus(payld);

                    console.log("payld =>  ", payld, "userSelDevice", userSelDevice, { roomStatusRes })

                    let showPay = {
                        willShow: true,
                        isDetecting: false,
                        devicePairing: false,
                        devicePaired: false,
                        isDetectingFailed: true,
                        connectFailed: false,
                        infoCode: INFO_CODE.NO_DEVICE_DETECT
                    }

                    let hasDevice = false;
                    if (roomStatusRes.availableDevice != undefined) {
                        if (roomStatusRes.availableDevice.length) {
                            hasDevice = true;
                        }
                    }

                    if (roomStatusRes.status == 1) {
                        let roomStatus = roomStatusRes;
                        console.log("roomStatus ", roomStatus)
                        if (roomStatus?.is_multiple) {
                            let user_ip_list = roomStatus.data.map(e => e.device_ip);
                            dispatch(setAvilableUserIP(user_ip_list))
                            roomStatus = {
                                data: roomStatusRes.data[0]
                            }
                        }

                        if (roomStatus.data?.info_code && roomStatus.data?.info_code != "") {
                            let allMessages = roomStatus.data.messages || [];

                            let saveData = {}
                            allMessages.map(e => {
                                saveData[e.info_code] = e;
                            })

                            if (roomStatus.data?.info_code?.length) {
                                // detect first code based on steps
                                showPay.infoCode = getFirstErrorInfoCode(roomStatus.data?.info_code, showPay.infoCode)

                                // showPay.infoCode = roomStatus.data?.info_code[0];
                            } else {
                            }

                            // showPay.infoCode = roomStatus.data?.info_code?.join(", ");

                            if (showPay.infoCode != INFO_CODE.NO_DEVICE_DETECT) {
                                showPay.isDetectingFailed = true
                            }

                            setInfoMessageView({
                                ...infoMessagesView,
                                ...saveData
                            })
                            // show modal if any error to user
                        } else {

                        }
                    }

                    console.log("userDeviceSubmit ", userDeviceSubmit)

                    // if (userDeviceSubmit) {
                    //     if (showPay.infoCode == INFO_CODE.NO_DEVICE_DETECT) {
                    //         showPay.infoCode = INFO_CODE.UNKNOWN_ERROR
                    //     }
                    // }

                    console.log("final save data", showPay, "existing code ", _allStore_v2.deviceInfoMessages.info_code);

                    if (_allStore_v2.deviceInfoMessages.info_code != INFO_CODE.NO_DEVICE_DETECT) {
                        // console.log("final save data b ", showPay, _allStore_v2.deviceInfoMessages.info_code);

                        // handleInfoClick(showPay.infoCode)
                        setDeviceStatus(showPay)
                        // setDeviceStepsStatus(showPay.infoCode)
                    }

                    let setType = "socket received error";

                    if (showPay.infoCode == INFO_CODE.NO_INTER) {
                        setType = RUNNING_PROCESS_TIGGER_POINT.INTERFACE_ERROR
                    } else if (showPay.infoCode == INFO_CODE.SYMMETRIC_NAT) { // port error
                        setType = RUNNING_PROCESS_TIGGER_POINT.PORT_ERROR
                    } else if (showPay.infoCode == INFO_CODE.NO_DEVICE_DETECT) {
                        setType = RUNNING_PROCESS_TIGGER_POINT.NO_DEVICE_DETECT
                    }

                    if (showPay.infoCode) {
                        if (showPay.infoCode?.indexOf(INFO_CODE.SYMMETRIC_NAT) != -1) {
                            if (_ValidateIPaddress(CURRENT_ROOM_NAME)) {
                                console.log("roomStatusResroomStatusRes A", roomStatusRes.data)
                                if (roomStatusRes?.data?.info_code.length > 1) {
                                    console.log("roomStatusResroomStatusRes B", roomStatusRes?.data?.info_code.indexOf(INFO_CODE.NO_INTER))

                                    if (roomStatusRes?.data?.info_code.indexOf(INFO_CODE.NO_INTER) != -1) {
                                        console.log("roomStatusResroomStatusRes C")

                                        showPay.infoCode = INFO_CODE.NO_INTER;
                                        setType = RUNNING_PROCESS_TIGGER_POINT.INTERFACE_ERROR;
                                    }
                                } else {
                                    showPay.infoCode = INFO_CODE.NO_DEVICE_DETECT;
                                    setType = RUNNING_PROCESS_TIGGER_POINT.NO_DEVICE_DETECT
                                }
                            }
                        }
                    }


                    console.log("setType ", setType, showPay)

                    dispatch(setPrejoinDeviceStepRunning(false))

                    // if i have an device but not have any error then is should stop at detecting device
                    // if device is active and has other error in db then stop steps at exact error
                    setRecheckingDevice(false)
                    if (hasDevice) {
                        if (showPay.infoCode == INFO_CODE.NO_DEVICE_DETECT) {
                            // don't get any error in db but i have a device
                            console.log("device is available, but device has not any errors " + showPay)
                            // setDeviceStepsWaiting(INFO_CODE.WAITING_DEVICE, false, false, RUNNING_PROCESS_TIGGER_POINT.DEVICE_NOT_ERROR_WAITING)
                            setDeviceStepsWaiting(INFO_CODE.WAITING_DEVICE, false, false, setType, "i have device and error is A " + showPay.infoCode)

                        } else {
                            // i have a device but having some error
                            // setDeviceStepsWaiting(showPay.infoCode, true, false, RUNNING_PROCESS_TIGGER_POINT.DEVICE_HAS_ERROR)
                            setDeviceStepsWaiting(showPay.infoCode, true, false, setType, "i have device and error is B " + showPay.infoCode)

                        }
                    } else {
                        setDeviceStepsWaiting(INFO_CODE.NO_DEVICE_DETECT, true, false, "device is not available")
                    }

                }
            } else {
                // console.log("case failed else ")
            }
        }
    }

    const setDeviceStepsStatus = (infoCode, willWait = false, from = null) => {
        let _allStore_v3 = getStore(FEATURE_CUSTOM_REDUX_V3);

        let messagesState = _allStore_v3.prejoinDeviceMessages;

        let currentFlag = "";
        let currentMessage = {}
        // if (messagesState.show) {
        // check where is current step of messages, it will stop
        // console.log("my info code received ", infoCode, "from ", from)

        currentFlag = getLastKey(messagesState.messages)
        // console.log("all objects a", objKeys)
        if (currentFlag) {
            // currentFlag = objKeys[objKeys.length - 1];
            currentMessage = messagesState.messages[currentFlag];
        }
        // console.log("all objects b", currentFlag, "current message ", currentMessage)

        // console.log("My current device serial is  ", currentFlag)

        if (_allStore_v3.prejoinDeviceStepsRunning == true) {
            // console.log("other flow is running 2nd ", _allStore_v3.prejoinDeviceStepsRunning, "where ", _allStore_v3.prejoinDeviceStepsRunningFlag)
            return false;
        }

        let setDefault = true;
        // console.log("My current", setDefault)
        if (setDefault) {
            let deviceMessage = Object.keys(DEVICE_INFO_MESSAGES);
            dispatch(setPrejoinDeviceStepRunning(true, "with error " + from))
            for (var i = 0; i < deviceMessage.length - 1; i++) { // subscription will be check once device is connected

                // console.log("=> keys ", deviceMessage, deviceMessage[i])
                let ke = deviceMessage[i];
                let val = DEVICE_INFO_MESSAGES[ke];

                // break if my error and default error match
                // console.log("my serial info code is  " + val.infoCode + " and my error info code is " + infoCode)
                (function (index) {
                    setTimeout(function () {
                        // console.log("inside main function B")
                        try {
                            let _allStateV3 = getStore(FEATURE_CUSTOM_REDUX_V3);
                            let existingVal = _allStateV3.prejoinDeviceMessages;
                            let lastKey = getLastKey(existingVal.messages)
                            let willMove = true;

                            // delete next key which are beyond current key
                            if (willMove) {
                                let allVal = {
                                    show: true,
                                    messages: {
                                        ...existingVal.messages,
                                        [ke]: val
                                    }
                                }

                                // console.log("I will set current status ", allVal)
                                dispatch(setPrejoinDeviceMessages(allVal))

                                if (val.infoCode == infoCode) {
                                    dispatch(setPrejoinDeviceStepRunning(false))
                                }

                                setTimeout(function () {
                                    let updated = {
                                        ...allVal
                                    }

                                    if (!willWait) {
                                        if (val.infoCode == infoCode) {
                                            updated.messages[ke].loading = false;
                                            updated.messages[ke].success = false;
                                            updated.messages[ke].failed = true;
                                            handleInfoClick(infoCode)
                                        } else {
                                            updated.messages[ke].loading = false;
                                            updated.messages[ke].success = true;
                                            updated.messages[ke].failed = false;
                                        }
                                        dispatch(setPrejoinDeviceMessages(updated))
                                    }
                                    // console.log("I will set current status set timeout  ", allVal)

                                    // console.log("Im stopping here because my error is matched with serial error at timeout, i'm setting values are as  ", updated)
                                }, WAITING_TIME.DEVICE_PROGRESS_TIME_AFTER)
                            }
                        } catch (e) {
                            // console.log("=> keys b A", e)
                        }
                    }, i * WAITING_TIME.DEVICE_PROGRESS_TIME);

                })(i);

                if (val.infoCode == infoCode) {
                    console.log("Im stopping here because my error is matched with serial error", val.infoCode, "received ", infoCode)
                    break;
                }
            }
        }
    }


    const setDeviceStepsWaiting = (stopInfoCode, isFailed = false, moveFast = false, from = null, additional = null) => {

        let _allStore_v3 = getStore(FEATURE_CUSTOM_REDUX_V3);

        console.log("i'm running in waiting screen code ", stopInfoCode, "is failed", isFailed, "moveFast", moveFast, "from", from, "additional ", additional)

        if (_allStore_v3.prejoinDeviceStepsRunning == true) {
            console.log("other flow is running waiting ", _allStore_v3.prejoinDeviceStepsRunning, "where ", _allStore_v3.prejoinDeviceStepsRunningFlag)
            return false;
        }

        // moveFast = false;
        let deviceMessage = Object.keys(DEVICE_INFO_MESSAGES);
        dispatch(setPrejoinDeviceStepRunning(true, from || "socket waiting", stopInfoCode))

        for (var i = 0; i < deviceMessage.length - 1; i++) { // subscription will be check once device is connected    
            let ke = deviceMessage[i];
            let val = DEVICE_INFO_MESSAGES[ke];

            // logData("recccc " + val + "key " + ke)

            (function (index) {
                setTimeout(function () {
                    try {
                        // Fix me i don't know when socket has not any error but there are interface error before it still showing interface error once then success immidiately
                        if (stopInfoCode == INFO_CODE.WAITING_DEVICE) {
                            if (ke == DEVICE_INFO_MESSAGES_KEYS.CHECK_INTERFACE) {
                                val.failed = false
                            }
                        }

                        // console.log("=> steps are on going current is A ", ke, "value ", val, "index ", index)

                        let _allStateV3 = getStore(FEATURE_CUSTOM_REDUX_V3);

                        // console.log("=> process storage ", _allStateV3.prejoinDeviceMessages)
                        let existingVal = _allStateV3.prejoinDeviceMessages;

                        let allVal = {
                            show: true,
                            messages: {}
                        }

                        if (index == 0) {
                            let firstMessage = {
                                [DEVICE_INFO_MESSAGES_KEYS.CHECK_DEVICE_INTERNET]: {
                                    ...DEVICE_DETECT_STEP,
                                    failed: false,
                                    success: false,
                                    loading: true
                                }
                            }

                            allVal.messages = firstMessage;
                            // }
                            // console.log("i'm the message number first ", allVal, "sssssssss ", DEVICE_INFO_MESSAGES[ke], "FIRST MESSAGE TO SHOW ", firstMessage)

                        } else {
                            if (existingVal.messages.hasOwnProperty(ke)) {
                                delete existingVal.messages[ke]
                            }

                            let curS = {
                                ...existingVal.messages,
                                [ke]: {
                                    ...val,
                                    loading: true,
                                    success: false,
                                    failed: false
                                }
                            }
                            allVal.messages = Object.assign(curS, allVal.messages);
                            // console.log("i'm the message number second ", allVal, "current savving ", curS)
                        }

                        // console.log("=> steps are on going current is B new set ", allVal, " existing ", existingVal)

                        dispatch(setPrejoinDeviceMessages(allVal))
                        setTimeout(function () {
                            let willMove = true;

                            let willBeFailed = false;

                            if (val.waitingCode != undefined) {
                                // console.log("has waiting code ", stopInfoCode)
                                if (val.waitingCode == stopInfoCode) {
                                    willBeFailed = true;

                                    willMove = false
                                }
                            }

                            if (stopInfoCode == val.infoCode) {
                                if (isFailed) {
                                    willMove = false;
                                    let _updated = {
                                        ...allVal
                                    }
                                    _updated.messages[ke].loading = false;
                                    _updated.messages[ke].success = false;
                                    _updated.messages[ke].failed = true;
                                    handleInfoClick(val.infoCode)
                                    console.log("I'm stopping here because case is failed ", stopInfoCode, "serial ", val.infoCode)
                                    dispatch(setPrejoinDeviceMessages(_updated))
                                    setTimeout(function () {
                                        // dispatch(setPrejoinDeviceStepRunning(false))
                                    }, 5000)
                                }
                            }

                            if (willMove) {
                                if (ke != DEVICE_INFO_MESSAGES_KEYS.CHECK_COMPATIBLE) {
                                    let updated = {
                                        ...allVal
                                    }
                                    if (updated.messages[ke] != undefined) {
                                        updated.messages[ke].loading = false;
                                        updated.messages[ke].success = true;
                                        dispatch(setPrejoinDeviceMessages(updated))
                                    }
                                }
                            } else {
                                if (willBeFailed) {
                                    setTimeout(async function () {
                                        let _allState_V3 = getStore(FEATURE_CUSTOM_REDUX_V3);
                                        let _allState_V1 = getStore(FEATURE_CUSTOM_REDUX);

                                        console.log("I have not got anything after long time out ", { _allState_V3 }, { _allState_V1 })

                                        if (_allState_V1.usersData == null && _allState_V3.prejoinDeviceStepsRunning && (_allState_V3.prejoinDeviceStepsRunningFlag == RUNNING_PROCESS_TIGGER_POINT.DEVICE_NOT_ERROR_WAITING || _allStateV3.prejoinDeviceStepsRunningFlag == RUNNING_PROCESS_TIGGER_POINT.NO_DEVICE_DETECT)) {

                                            let myStatusId = fetchMyStaticDevice();
                                            if (!myStatusId) {
                                                myStatusId = myStaticDevice;
                                            }
                                            if (!myStaticDevice) {
                                                if (_allState_V3.userBoxStaticDeviceId) {
                                                    myStatusId = _allState_V3.userBoxStaticDeviceId
                                                }
                                            }

                                            console.log("I have selected my device ", myStatusId)

                                            let willRecheck = false;
                                            if (myStatusId) {
                                                if (_allState_V1.deviceList.indexOf(myStatusId) != -1) {
                                                    willRecheck = true;
                                                    pairDevice(myStatusId)
                                                    console.log("I will try to reconnect with device")
                                                }
                                            }

                                            console.log("willRecheckwillRecheck ", willRecheck)

                                            if (!willRecheck) {
                                                var _log_data = {
                                                    functionName: '',
                                                    triggeredBy: 'automatic',
                                                    event: "waiting-for-device-in-list",
                                                    requestData: {
                                                        publicIp: getDeviceIp,
                                                        device_id: myStatusId,
                                                        tempRoom: TEMP_ROOM,
                                                        visibleRoom: CURRENT_ROOM_NAME,
                                                        status: false
                                                    },
                                                    responseData: '',
                                                    userId: props?.userLoginData?.user?.id,
                                                    boxId: myStatusId,
                                                    message: 'Emit to server'
                                                }
                                                SaveLog(_log_data);
                                                // console.log("I have not got anything after long time");
                                                // 
                                                var message = {
                                                    action: {
                                                        publicIp: getDeviceIp,
                                                        userId: props.userLoginData?.user?.id || null
                                                    },
                                                    content: 'device-list',
                                                    isBroadcast: true,
                                                    sender: 'mobile',
                                                    scope: "prejoin-b"
                                                }
                                                sendData(message);
                                                // wait for 10 sec fetch devices list we my device is in list
                                                await sleep(10000);

                                                console.log("I have not got anything after long time B", new Date());


                                                let _updated = {
                                                    ...allVal
                                                }
                                                _updated.messages[ke].loading = false;
                                                _updated.messages[ke].success = false;
                                                _updated.messages[ke].failed = true;
                                                handleInfoClick(INFO_CODE.UNKNOWN_ERROR_CONNECT)
                                                dispatch(setPrejoinDeviceMessages(_updated))
                                                dispatch(setPrejoinDeviceStepRunning(false))
                                            }
                                        }
                                    }, WAITING_TIME.FINAL_WAITING * 1000);
                                }
                                if (!willBeFailed) {
                                    // dispatch(setPrejoinDeviceStepRunning(false))
                                }
                            }
                        }, moveFast ? 200 : WAITING_TIME.DEVICE_PROGRESS_TIME_AFTER)

                    } catch (e) {
                        console.log("=> keys b", e)
                    }
                }, moveFast ? 500 : i * WAITING_TIME.DEVICE_PROGRESS_TIME);

            })(i);

            if (val.infoCode == stopInfoCode) {
                // console.log("Im stopping here because my error is matched with serial error in waiting function ", val.infoCode, "received ", stopInfoCode)
                break;
            }
        }
    }

    // }

    const deviceAvailableStatus = (type = "audio", additional = null) => {
        let showType = {
            status: true,
            infoCode: ""
        };

        let _availableDevices = availableDevices;
        let _permissions = permissions;
        let _mediaAllowed = mediaAllowed;

        if (additional) {
            if (additional.hasOwnProperty("availableDevices")) {
                _availableDevices = additional.availableDevices
            }
            if (additional.hasOwnProperty("permissions")) {
                _permissions = additional.permissions
            }
            if (additional.hasOwnProperty("mediaAllowed")) {
                _mediaAllowed = additional.mediaAllowed
            }
        }
        // console.log("before join")
        // console.log("all devices dev ", { _availableDevices }, { availableDevices }, { _permissions }, { _mediaAllowed })


        if (!_availableDevices[type + "Input"].length) {
            return showType = {
                status: false,
                infoCode: type == "audio" ? INFO_CODE.MICROPHONE_NOT_AVAILABLE : INFO_CODE.WEBCAM_NOT_AVAILABLE
            }
        } else {
            let _videoTrack = props.videoTrack;
            // if (!_videoTrack && type == "video") {
            //     return showType = {
            //         status: false,
            //         infoCode: INFO_CODE.WEBCAM_NOT_AVAILABLE
            //     }
            // } else
            if (!_permissions[type]) {
                return showType = {
                    status: false,
                    infoCode: type == "audio" ? INFO_CODE.MICROPHONE_NOT_ALLOWED : INFO_CODE.WEBCAM_NOT_ALLOWED
                }
            } else {
                if (type == "audio" && _mediaAllowed[type].muted) {
                    return showType = {
                        status: false,
                        infoCode: INFO_CODE.MICROPHONE_MUTED
                    }

                } else if (type == "video" && _mediaAllowed[type].muted != 0) {
                    return showType = {
                        status: false,
                        infoCode: INFO_CODE.WEBCAM_MUTED
                    }
                }
            }
        }

        if (showType.status) {
            let videoTrack = props.videoTrack;
            if (!videoTrack && type == "video") {
                return showType = {
                    status: false,
                    infoCode: INFO_CODE.WEBCAM_NOT_AVAILABLE
                }
            }
        }
        return showType;
    }

    useEffect(async () => {
        console.log("device has changes or detect timeout ", deviceList, "detectDeviceTimer", detectDeviceTimer, "prejoinScreenDetail", prejoinScreenDetail, "flagType", flagType)
        if (!prejoinScreenDetail.isSet && flagType == STATUS_FLAG.DETECT_DEVICE) {
            let willMove = true;
            let availDev = await getAvailableDevice();
            if (availDev.availableDevice.length) {
                if (availDev.availableDevice.length > 1) {
                    willMove = false;
                    if (!userBoxStaticDeviceId) {
                        setShowMultiDevice(true)
                    }
                }
            }

            if (!willMove) {
                if (userBoxStaticDeviceId) {
                    willMove = true
                }
            }

            console.log("Init will Move", willMove)
            if (willMove) {
                detectAndJoinDevice()
            }
        }
    }, [deviceList, detectDeviceTimer]);

    const { userBoxStaticDeviceId } = props;
    let prevDevice = usePrevious(userBoxStaticDeviceId)
    useEffect(() => {
        if (prevDevice != userBoxStaticDeviceId) {
            if (userBoxStaticDeviceId) {
                if (!prejoinScreenDetail.isSet) {
                    setMyStaticDevice(userBoxStaticDeviceId)
                    setTimeout(function () {
                        detectAndJoinDevice(true, userBoxStaticDeviceId)
                    }, 100)
                }
            }
        }
    }, [userBoxStaticDeviceId])

    // handle user mute/unmute, allow/not allow, available/not available
    const { browserDeviceStatus, deviceInfoMessages } = props;
    useEffect(function () {
        let videoStatus = deviceAvailableStatus("video", {
            availableDevices,
            mediaAllowed,
            permissions
        });

        let audioStatus = deviceAvailableStatus();

        dispatch(setBrowserDeviceStatus({
            video: videoStatus,
            audio: audioStatus
        }))

        if (videoStatus.status == true && videoStatus.infoCode == "") {
            if (deviceInfoMessages.show && deviceInfoMessages.info_code == INFO_CODE.ALL_SET) {

            } else {
                dispatch(setDeviceInfoMessage({
                    show: false,
                    messages: []
                }, 8))
            }
        }
    }, [availableDevices, mediaAllowed, permissions]);

    let prevPremission = usePrevious(permissions);
    useEffect(() => {
        if (prevPremission) {
            if (prevPremission?.audio != permissions.audio) {
                if (permissions.audio) {
                    dispatch(setAudioMuted(false));
                    dispatch(muteLocal(false, MEDIA_TYPE.AUDIO))
                }
            }
            if (prevPremission?.video != permissions.video) {
                if (permissions.video) {
                    dispatch(setVideoMuted(false));
                    dispatch(setVideoMuted(false, "video", VIDEO_MUTISM_AUTHORITY.USER, true));
                }
            }
        }
    }, [permissions]);

    const prevBrowserDeviceStatus = usePrevious(browserDeviceStatus);
    // when user enable disable, mute unmute allow disallow media devices
    //process to next

    useEffect(function () {
        setTimeout(function () {
            if (prevBrowserDeviceStatus) {
                if (prevBrowserDeviceStatus.video.infoCode != browserDeviceStatus.video.infoCode) {
                    if (browserDeviceStatus.video.infoCode == "" && browserDeviceStatus.video.status) {
                        // hide the modal if opened
                        if (deviceInfoMessages.show) {
                            if (deviceInfoMessages.info_code == INFO_CODE.WEBCAM_NOT_ALLOWED
                                || deviceInfoMessages.info_code == INFO_CODE.WEBCAM_NOT_AVAILABLE
                                || deviceInfoMessages.info_code == INFO_CODE.WEBCAM_MUTED) {
                                dispatch(setDeviceInfoMessage({
                                    show: false,
                                    messages: [],
                                    info_code: ""
                                }, 9))
                            }
                        }
                        // process to next 
                        // if user on very first step i.e video step then this process will proceed else video was detected but user has disallow or mute the camera
                        setTimeout(function () {
                            console.log("user browser media changed A")
                            if (!props.prejoinSubscription.show_basic && !props.prejoinSubscription.show_premium) {
                                console.log("user browser media changed B")
                                if (!deviceStatus.willShow) {
                                    // console.log("video has allowded by user detect device")
                                    sessionStorage.removeItem("userWebcamDenied")
                                    // sessionStorage.removeItem("video");
                                    dispatch(setDeviceInfoMessage({
                                        show: false,
                                        messages: [],
                                        info_code: ""
                                    }, 10))
                                    getStatus(STATUS_FLAG.DETECT_DEVICE, 6)
                                }
                            }
                            console.log("user browser media changed C")
                        }, 1000)
                    }
                }
                if (prevBrowserDeviceStatus.audio.infoCode != browserDeviceStatus.audio.infoCode) {
                    if (prevBrowserDeviceStatus.audio.infoCode != browserDeviceStatus.audio.infoCode) {
                        if ((browserDeviceStatus.audio.infoCode == "" || browserDeviceStatus.audio.infoCode == INFO_CODE.WEBCAM_MUTED)) {
                            if (showAudio == true) {
                                if (props.joinRoomWithoutDevice == false) {
                                    // dispatch(setUserPrejoinAllSet(true))
                                    dispatch(setJoinRoomWithoutDevice(true, 1))
                                    let { uniqueId, conferenceJoined } = getStore(FEATURE_CUSTOM_REDUX)
                                    if (getBaseConfig("showPreJoiningInConference") && conferenceJoined) {
                                        // let now_time = Math.round(new Date().getTime() / 1000);
                                        // sessionStorage.setItem("dv_cnf_tm", JSON.stringify({
                                        //     time: now_time,
                                        //     id: uniqueId
                                        // }))
                                    } else {
                                        dispatch(setDeviceInfoMessage({
                                            show: true,
                                            messages: [],
                                            info_code: INFO_CODE.ALL_SET
                                        }, 11))
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }, 3000)
    }, [browserDeviceStatus])

    const pUsersData = usePrevious(usersData);

    useEffect(async () => {

        // console.log("users data changed ", usersData, "pUsersData", pUsersData, !isEqual(pUsersData, usersData))

        if (usersData != undefined && usersData != null && usersData != "") {
            // console.log("device connected a", usersData, "pUsersData", pUsersData)
            if (!isEqual(pUsersData, usersData)) {
                if (pUsersData == null && usersData != null) {
                    // console.log("device connected b")

                    // if (connectRequested && !window.isDeviceConnected) {
                    window.isDeviceConnected = true;
                    setDeviceStatus({
                        willShow: true,
                        infoCode: "",
                        isDetecting: false,
                        devicePairing: false,
                        devicePaired: true,
                        isDetectingFailed: false,
                        connectFailed: false
                    })
                    setDeviceConnected(true)
                    setConnectRequested(false)

                    let allStore_v3 = getStore(FEATURE_CUSTOM_REDUX_V3)

                    console.log("allStore_v3 ", allStore_v3)
                    let prejoinMessages = allStore_v3.prejoinDeviceMessages;

                    if (prejoinMessages) {
                        if (prejoinMessages.show) {
                            if (prejoinMessages.messages.hasOwnProperty(DEVICE_INFO_MESSAGES_KEYS.CHECK_COMPATIBLE)) {

                                prejoinMessages.messages[DEVICE_INFO_MESSAGES_KEYS.CHECK_COMPATIBLE].loading = false
                                prejoinMessages.messages[DEVICE_INFO_MESSAGES_KEYS.CHECK_COMPATIBLE].success = true
                            } else {
                                console.log("device is connected but connecting key is not available to adding key first")
                                let compatibleMsg = DEVICE_INFO_MESSAGES[DEVICE_INFO_MESSAGES_KEYS.CHECK_COMPATIBLE]
                                prejoinMessages.messages = Object.assign({
                                    [DEVICE_INFO_MESSAGES_KEYS.CHECK_COMPATIBLE]: {
                                        ...compatibleMsg,
                                        success: true,
                                        loading: false,
                                        failed: false
                                    },
                                }, prejoinMessages.messages)
                            }
                        }

                        // console.log("device connected ", prejoinMessages.messages)

                        dispatch(setPrejoinDeviceMessages({
                            show: true,
                            messages: {
                                ...prejoinMessages.messages
                            }
                        }))
                    }

                    let willMove = true;

                    if (getBaseConfig("calculateDevicePing") == true) {
                        let calculationRes = await prejoinDeviceCalc({
                            uniqueID: usersData.uniqueId,
                            visibleRoom: CURRENT_ROOM_NAME,
                            protocolId
                        })
                        // console.log("calculationRes ", calculationRes)
                        if (calculationRes.status == 1) {
                            if (calculationRes?.data?.type == 1) {
                                willMove = false
                                dispatch(setPrejoinDevicePingCalculate(prejoinDeviceCalculateFlag.WAITING))
                            } else {
                                dispatch(setPrejoinDevicePingCalculate(prejoinDeviceCalculateFlag.DEFAULT))
                            }
                        } else {
                            dispatch(setPrejoinDevicePingCalculate(prejoinDeviceCalculateFlag.DEFAULT))
                        }
                        console.log("calculation res ", calculationRes)
                    }

                    console.log("Device paired successfully ", usersData, "willMove ", willMove);
                    dispatch(setPrejoinDeviceStepRunning(false))

                    dispatch(setPrejoinSocketDWaiting(false));

                    // dispatch(setDeviceInfoMessage({
                    //     show: true,
                    //     messages: [],
                    //     info_code: INFO_CODE.ALL_SET
                    // }))
                    // setInit(false)
                    // setShowAudio(true)

                    if (willMove) {
                        setTimeout(function () {
                            showUSubscription(true)
                        }, 1000)
                    }
                    // }
                }
            }
        }

        if (pUsersData != usersData) {
            if (pUsersData != null && usersData == null) {
                console.log("users device disconnected");
                dispatch(setPrejoinScreenDetail({
                    isSet: false,
                    roomname: "",
                    uniqueId: "",
                    scope: "user disconnect successfully"
                }))

                let _store_v3 = getStore(FEATURE_CUSTOM_REDUX_V3);

                console.log("=> users device disconnected ", _store_v3.prejoinDeviceStepsRunning)

                if (_store_v3.prejoinDeviceStepsRunning == false) {
                    // console.log("=> I will recheck system ", _store_v3.prejoinDeviceStepsRunning)
                    setShowAudio(false)
                    getStatus(STATUS_FLAG.DETECT_DEVICE, 7)
                    dispatch(setPrejoinSubscriptionUI({
                        show_basic: false,
                        basic_checking: "",
                        show_premium: false
                    }))
                    setRecheckingDevice(true)
                    setTimeout(function () {
                        setRecheckingDevice(false)
                    }, 10000)
                    // reCheckSystem(true)
                } else {
                    console.log("Other process seems working")
                }
            }
        }
    }, [usersData])

    let prevSubscription = usePrevious(props.userPaymentSubscription)
    useEffect(() => {
        // device connected then show premium subscription
        let willMove = false;
        // console.log("user subscription 1 ", prevSubscription, props.userPaymentSubscription)
        if (!_.isEqual(prevSubscription, props.userPaymentSubscription)) {
            willMove = true;
            if (prevSubscription == undefined && props.userPaymentSubscription != undefined) {
                willMove = true;
            } else if (Object.keys(prevSubscription).length) {
                if (prevSubscription.pack_id != props.userPaymentSubscription.pack_id) {
                    willMove = true;
                } else if (prevSubscription.pack_id == props.userPaymentSubscription.pack_id) {
                    if (prevSubscription.end_at != props.userPaymentSubscription.end_at) {
                        willMove = true;
                    }
                }
            }
        }

        // console.log("user subscription 2 ", props.prejoinDeviceMessages?.messages[DEVICE_INFO_MESSAGES_KEYS.CHECK_DEVICE_INTERNET], props.prejoinDeviceMessages?.messages[DEVICE_INFO_MESSAGES_KEYS.CHECK_DEVICE_INTERNET] == undefined)

        try {
            if (props.prejoinDeviceMessages?.messages[DEVICE_INFO_MESSAGES_KEYS.CHECK_DEVICE_INTERNET] == undefined) {
                willMove = false;
                // console.log("Connect failed B", willMove)
            } else if (props.prejoinDeviceMessages?.messages[DEVICE_INFO_MESSAGES_KEYS.CHECK_DEVICE_INTERNET].loading == true) {
                willMove = false;
                // console.log("Connect failed A", willMove)
                return false;
            }
        } catch (e) {

        }

        if (getBaseConfig("noDevicePreJoiningScreen")) {
            willMove = true;
        }

        // console.log("Connect failed B ", willMove)

        if (willMove) {
            // console.log("points 2")

            setTimeout(function () {
                // console.log("points 3")

                let subscription = willAskSubscription();
                // console.log("user subscription 3 ", subscription, "usersData", usersData, "props.prejoinSubscription", props.prejoinSubscription)

                // console.log("User subscription changed ", { subscription }, "props", { usersData }, props.prejoinSubscription)
                if (usersData != null && !props.prejoinSubscription.show_basic) {
                    // console.log("points 4")

                    if (subscription.premium) {
                        // console.log("points 5")

                        checkUserSubsFn(false)
                    } else {
                        // console.log("points 6")

                        if (subscription.basic) {
                            // console.log("points 7")

                            dispatch(setPrejoinSubscriptionUI({
                                show_basic: true,
                                basic_checking: ct("rta-trmc.premeeting.checkingBasicSubscription"),
                                show_premium: false
                            }))
                            setTimeout(function () {
                                dispatch(setPrejoinSubscriptionUI({
                                    show_basic: true,
                                    basic_checking: "",
                                    show_premium: false
                                }))
                            }, 500)
                            setTimeout(function () {
                                _showAllSet(2)
                            }, 1000)
                        } else {
                            // console.log("points 8")

                            checkUserSubsFn(true)
                        }
                    }
                    // show basic subscription
                } else if (props.prejoinSubscription.show_basic) {
                    // console.log("points 9")

                    if (subscription.premium || subscription.basic) {
                        // console.log("points 10")

                        if (subscription.premium && subscription.basic) {
                            // console.log("points 12")
                            if (usersData != null && props.prejoinSubscription.show_basic) {
                                // console.log("points 13")
                                dispatch(setPrejoinSubscriptionUI({
                                    show_basic: false,
                                    basic_checking: "",
                                    show_premium: false
                                }))
                                showUSubscription(true)
                            } else if (props.prejoinSubscription.show_basic) {

                                let store_v2 = getStore(FEATURE_CUSTOM_REDUX_V2);
                                if (store_v2.joinRoomWithoutDevice == false) {
                                    _showAllSet(3)
                                }
                                // console.log("points 30 without box with prem subscs")

                            }
                        } else {
                            // console.log("points 14")

                            setTimeout(function () {
                                // console.log("points 11")
                                _showAllSet(4)
                            }, 2000)
                        }
                    }
                }
            }, 5000)
        }
    }, [props.userPaymentSubscription])

    const iconMap = {
        warning: {
            src: IconRedCross,
            className: 'device-icon--warning'
        },
        ok: {
            src: IconCheckSolid,
            className: 'device-icon--ok'
        }
    };

    let deviceStatusType = "ok"

    const classes = useStyles();

    const errorSrc = iconMap.warning.src;
    const okSrc = iconMap.ok.src;

    const errorClass = iconMap.warning.className;
    const okClass = iconMap.ok.className;

    const hasError = deviceStatusType === 'warning';
    const containerClassName = clsx("fadeIn ", { 'device-status-error': hasError }) + " device-room-info-content-lists";

    const renderDeviceUI_V2 = () => {
        const { prejoinDeviceMessages } = props;
        // console.log("prejoinDeviceMessages ", prejoinDeviceMessages)
        if (prejoinDeviceMessages.show) {
            let data = [];
            let lengths = Object.keys(prejoinDeviceMessages.messages).length;
            let i = 0;
            Object.keys(prejoinDeviceMessages.messages).map((k, v) => {
                i++;
                let val = prejoinDeviceMessages.messages[k];
                if (val.loading) {
                    data.push(<div className="w-100 d-flex loading-content" key={k}>
                        <span
                            style={{
                                marginLeft: "32px"
                            }}>
                            {ct(val.check_message)} <SpinnerLoader size="small" />
                        </span>
                    </div>
                    )
                } else if (val.success) {
                    data.push(<div className={lengths == i ? "ui-system-status" : "pb-3 ui-system-status"} key={k} >
                        <Icon
                            className={`device-icon ${okClass}`}
                            size={16}
                            src={okSrc}
                        />
                        <span
                            style={{
                                marginLeft: "15px"
                            }}>
                            {ct(val.success_message)}
                        </span>
                    </div>)
                } else if (val.failed) {
                    data.push(<div className={"pb-3 w-100 d-flex"} key={k}>
                        <Icon
                            className={`device-icon ${errorClass}`}
                            size={16}
                            src={errorSrc}
                        />
                        <span
                            style={{
                                marginLeft: "15px"
                            }}>
                            <div className="w-100 d-flex yes">
                                <span>{ct(val.failed_message)}</span>
                                <Tooltip
                                    title={ct("rta-trmc.premeeting.clickToView")}
                                    placement="right"
                                    arrow
                                    id="prejoin-info-icon-device"
                                    onClick={() => handleInfoClick(val.infoCode)}
                                >
                                    <img src="/images/info.svg" height="21px" width="21px" className="prejoin-info-icon pointer" />
                                </Tooltip>
                                <span className="ml-2 mw-50">
                                    {val.infoCode}
                                </span>
                            </div>
                        </span>
                    </div>)
                }
            })

            return (
                <>
                    <div
                        className={containerClassName}
                    >{data}</div>
                </>
            )
        }
        return null;
    }


    const renderInternetUI = () => {
        let data = null;

        if (internetMeasure.willShow) {
            if (internetMeasure.isDetecting) {
                data = <>
                    <Icon
                        className={`device-icon ${okClass}`}
                        size={16}
                        src={okSrc}
                    />
                    <span role='heading'
                        style={{
                            marginLeft: "15px"
                        }}>
                        {ct("rta-trmc.premeeting.internetDetecting")} <SpinnerLoader size="small" />
                    </span>
                </>
            } else if (internetMeasure.showSpeed) {
                data = <>
                    <Icon
                        className={`device-icon ${okClass}`}
                        size={16}
                        src={okSrc}
                    />
                    <span role='heading'
                        style={{
                            marginLeft: "15px"
                        }}>
                        {ct("rta-trmc.premeeting.internetDetected")}  {internetMeasure.speed + " mbps"}
                    </span>
                </>
            } else if (deviceStatus.isDetectingFailed) {
                data = <>
                    <Icon
                        className={`device-icon ${errorClass}`}
                        size={16}
                        src={okSrc}
                    />
                    <span role='heading'
                        style={{
                            marginLeft: "15px"
                        }}
                        className="d-flex w-100"
                    >
                        <span>{ct("rta-trmc.premeeting.internetDetectFailed")}</span>
                        <Tooltip
                            title={ct("rta-trmc.premeeting.clickToView")}
                            placement="right"
                            arrow
                            id="prejoin-info-icon-device"
                            onClick={() => handleInfoClick(INFO_CODE.R_NET_SPEED)}
                        >
                            <img src="/images/info.svg" height="21px" width="21px" className="prejoin-info-icon pointer" />
                        </Tooltip>
                        <span className="ml-2 mw-50">
                            {INFO_CODE.R_NET_SPEED}
                        </span>
                    </span>
                </>
            }
        }

        if (data) {
            return (
                <>
                    <div
                        className={containerClassName + " d-flex w-100"}
                    >
                        {data}

                    </div>
                </>
            )
        }
        return data;
    }

    const renderMediaUI = (type = "audio") => {
        let data = null;
        let showType = true;
        const { videoTrack } = props;
        // console.log("device length a", availableDevices, "time ", new Date())
        let isMute = false;
        if (!availableDevices[type + "Input"].length) {
            showType = false;
            data = <span role='heading'
                style={{
                    marginLeft: "15px"
                }}
                className="d-flex w-100"
            >
                <span>
                    {ct("rta-trmc.premeeting." + type + "NotAvailable")}
                </span>
                <Tooltip
                    title={ct("rta-trmc.premeeting.clickToView")}
                    placement="right"
                    arrow
                    id="prejoin-info-icon-device"
                    onClick={() => handleInfoClick(type == "audio" ? INFO_CODE.MICROPHONE_NOT_AVAILABLE : INFO_CODE.WEBCAM_NOT_AVAILABLE, true)}
                >
                    <img src="/images/info.svg" height="21px" width="21px" className="prejoin-info-icon pointer" />
                </Tooltip>
                <span className="ml-2 mw-50">
                    {type == "audio" ? INFO_CODE.MICROPHONE_NOT_AVAILABLE : INFO_CODE.WEBCAM_NOT_AVAILABLE}
                </span>
            </span>
        } else {
            if (!permissions[type]) {
                showType = false;

                data = <span role='heading'
                    style={{
                        marginLeft: "15px"
                    }}
                    className="d-flex w-100"
                >
                    <span>
                        {/* {infoMessages[type + "NotAllowed"]} */}
                        {ct("rta-trmc.premeeting." + type + "NotAllowed")}
                    </span>

                    <Tooltip
                        title={ct("rta-trmc.premeeting.clickToView")}
                        placement="right"
                        arrow
                        id="prejoin-info-icon-device"
                        onClick={() => handleInfoClick(type == "audio" ? INFO_CODE.MICROPHONE_NOT_ALLOWED : INFO_CODE.WEBCAM_NOT_ALLOWED, true)}
                    >
                        <img src="/images/info.svg" height="21px" width="21px" className="prejoin-info-icon pointer" />
                    </Tooltip>
                    <span className="ml-2 mw-50">
                        {type == "audio" ? INFO_CODE.MICROPHONE_NOT_ALLOWED : INFO_CODE.WEBCAM_NOT_ALLOWED}
                    </span>
                </span>
            } else {
                if (type == "audio" && mediaAllowed[type].muted) {
                    showType = false;
                    isMute = true;

                    data = <span role='heading'
                        style={{
                            marginLeft: "15px"
                        }}
                        className="d-flex w-100"
                    >
                        <span>
                            {
                                (usersData != null || usersData != undefined) && props.prejoinSubscription.show_basic == false
                                    ? ct("rta-trmc.premeeting.deviceConnectNoAudio")
                                    : ct("rta-trmc.premeeting." + type + "Muted")
                            }
                        </span>
                        {
                            (usersData != null || usersData != undefined) && props.prejoinSubscription.show_basic == false
                                ? null : <>
                                    <Tooltip
                                        title={ct("rta-trmc.premeeting.clickToView")}
                                        placement="right"
                                        arrow
                                        id="prejoin-info-icon-device"
                                        onClick={() => handleInfoClick(INFO_CODE.MICROPHONE_MUTED, true)}
                                    >
                                        <img src="/images/info.svg" height="21px" width="21px" className="prejoin-info-icon pointer" />
                                    </Tooltip>
                                    <span className="ml-2 mw-50">
                                        {INFO_CODE.MICROPHONE_MUTED}
                                    </span>
                                </>
                        }
                    </span>
                } else if (type == "video" && mediaAllowed[type].muted != 0) {
                    showType = false;

                    data = <span role='heading'
                        style={{
                            marginLeft: "15px"
                        }}
                        className="d-flex w-100"
                    >
                        <span>
                            {/* {infoMessages[type + "Muted"]} */}
                            {ct("rta-trmc.premeeting." + type + "Muted")}
                        </span>
                        <Tooltip
                            title={ct("rta-trmc.premeeting.clickToView")}
                            placement="right"
                            arrow
                            id="prejoin-info-icon-device"
                            onClick={() => handleInfoClick(INFO_CODE.WEBCAM_MUTED, true)}
                        >
                            <img src="/images/info.svg" height="21px" width="21px" className="prejoin-info-icon pointer" />
                        </Tooltip>
                        <span className="ml-2 mw-50">
                            {INFO_CODE.WEBCAM_MUTED}
                        </span>
                    </span>
                }
            }
        }

        if (showType) {
            if (type == "video" && !videoTrack) {
                showType = false;
                data = <span role='heading'
                    style={{
                        marginLeft: "15px"
                    }}
                    className="d-flex w-100"
                >
                    <span>
                        {/* {infoMessages[type + "NotAvailable"]} */}
                        {ct("rta-trmc.premeeting." + type + "NotAvailable")}
                    </span>
                    <Tooltip
                        title={ct("rta-trmc.premeeting.clickToView")}
                        placement="right"
                        arrow
                        id="prejoin-info-icon-device"
                        onClick={() => handleInfoClick(INFO_CODE.WEBCAM_NOT_AVAILABLE, true)}
                    >
                        <img src="/images/info.svg" height="21px" width="21px" className="prejoin-info-icon pointer" />
                    </Tooltip>
                    <span className="ml-2 mw-50">
                        {INFO_CODE.WEBCAM_NOT_AVAILABLE}
                    </span>
                </span>
            }
        }

        if (showType) {
            // try {
            //     sessionStorage.setItem(type, true);
            // } catch (e) {
            //     console.log("device error", e)
            // }
            data = <span role='heading'
                style={{
                    marginLeft: "15px"
                }}
                className={"w-100 "}
            >
                <span>
                    {/* {infoMessages[type + "Working"]} */}
                    {ct("rta-trmc.premeeting." + type + "Working")}
                </span>
            </span>
        }

        if (data) {
            return (<div
                className={containerClassName + " ui-system-status w-100 " + (type == "audio" && !props.prejoinSubscription?.show_basic && props.prejoinDevicePingCalculation == prejoinDeviceCalculateFlag.DEFAULT ? classes.marginTopNgThirtn : "")}
            >
                {
                    type == "audio" && isMute && !getBaseConfig("noDevicePreJoiningScreen") ?
                        <Icon
                            className={`device-icon theme-color-icon`}
                            size={16}
                            src={IconInfo}
                        />
                        :
                        <Icon
                            className={`device-icon ${showType ? okClass : errorClass}`}
                            size={16}
                            src={showType ? okSrc : errorSrc}
                        />
                }
                {data}
            </div>
            )
        }
        return null;
    }

    const renderBasicSubscriptionUI = () => {
        let data = null;

        const { prejoinSubscription } = props;
        if (props.prejoinDeviceMessages?.messages[DEVICE_INFO_MESSAGES_KEYS.CHECK_DEVICE_INTERNET] == undefined && !getBaseConfig("noDevicePreJoiningScreen")) {
            return data;
        }

        if (props.prejoinDeviceMessages?.messages[DEVICE_INFO_MESSAGES_KEYS.SUBSCRIPTION_SHOW] != undefined) {
            console.log("subscription was already showing");
            return null;
        }

        if (prejoinSubscription.show_basic) {
            let subscription = willAskSubscription();

            if (prejoinSubscription.basic_checking) {
                dispatch(setPremeetingSubscriptionUI(false))
                data = <div
                    className={containerClassName + " d-flex w-100 " + (props.prejoinDevicePingCalculation == prejoinDeviceCalculateFlag.DEFAULT ? classes.marginTopNgThirtn : "")}
                ><div className="pb-3 w-100 d-flex loading-content" >
                        <span
                            style={{
                                marginLeft: "32px"
                            }}>
                            {ct(prejoinSubscription.basic_checking)} <SpinnerLoader size="small" />
                        </span>
                    </div>
                </div>
            } else if (!subscription.basic && !subscription.premium) {
                dispatch(setPremeetingSubscriptionUI(false))
                data = <div
                    className={containerClassName + " d-flex w-100" + (props.prejoinDevicePingCalculation == prejoinDeviceCalculateFlag.DEFAULT ? classes.marginTopNgThirtn : "")}
                >
                    <Icon
                        className={`device-icon ${errorClass}`}
                        size={16}
                        src={errorSrc}
                    />
                    <span role='heading'
                        style={{
                            marginLeft: "15px"
                        }}
                        className="d-flex w-100"
                    >
                        <span>
                            {/* {infoMessages.basic_subscription_not} */}
                            {ct("rta-trmc.premeeting.basicSubscriptionNot")}
                        </span>
                        <Tooltip
                            title={ct("rta-trmc.premeeting.clickToView")}
                            placement="right"
                            arrow
                            id="prejoin-info-icon-device"
                            onClick={() => handleInfoClick(INFO_CODE.BASIC_SUBSCRIPTION)}
                        >
                            <img src="/images/info.svg" height="21px" width="21px" className="prejoin-info-icon pointer" />
                        </Tooltip>
                        <span className="ml-2 mw-50">{INFO_CODE.BASIC_SUBSCRIPTION}</span>
                    </span>
                </div>
            } else {
                dispatch(setPremeetingSubscriptionUI(true))
                let { conferenceJoined } = getStore(FEATURE_CUSTOM_REDUX)
                data = <>
                    <div
                        className={containerClassName + " d-flex w-100  basic_subs custom-subs" + (props.prejoinDevicePingCalculation == prejoinDeviceCalculateFlag.DEFAULT ? classes.marginTopNgThirtn : "")}
                    >
                        <Icon
                            className={conferenceJoined ? `device-icon theme-color-icon theme-color-icon-inside` : `device-icon theme-color-icon`}
                            size={14}
                            src={okSrc}
                        />
                        <span role='heading'
                            style={{
                                marginLeft: "15px"
                            }}
                            className="d-flex w-100"
                        >
                            <span>
                                {subscription.premium ? ct("rta-trmc.premeeting.premium_subscription") : ct("rta-trmc.premeeting.basic_subscription")}
                            </span>
                        </span>
                    </div>
                </>
            }
        }
        return data;
    }

    const handleInfoClick = (info_code, skip_device_flag = false) => {
        if (info_code) {
            let setMessages = [];
            if (info_code.indexOf(", ") != -1) {

                info_code.split(", ").map((e) => {
                    if (infoMessagesView[e] != undefined) {
                        setMessages.push(infoMessagesView[e])
                    }
                })
            } else {
                if (infoMessagesView[info_code] != undefined) {
                    setMessages.push(infoMessagesView[info_code])
                }
            }

            // if (setMessages.length) {

            // let { allUserDevices } = getStore(FEATURE_CUSTOM_REDUX_V2)
            // if (info_code == INFO_CODE.NO_DEVICE_DETECT) {
            //     if (allUserDevices && allUserDevices.length) {
            //         info_code = INFO_CODE.REGISTER_DEVICE;
            //     }
            // }
            if (userDeviceSubmit) {
                if (info_code == INFO_CODE.NO_DEVICE_DETECT) {
                    info_code = INFO_CODE.UNKNOWN_ERROR
                }
            }

            if (info_code != INFO_CODE.MICROPHONE_NOT_ALLOWED
                && info_code != INFO_CODE.MICROPHONE_NOT_AVAILABLE
                && info_code != INFO_CODE.MICROPHONE_MUTED
                && info_code != INFO_CODE.WEBCAM_NOT_ALLOWED
                && info_code != INFO_CODE.WEBCAM_NOT_AVAILABLE
                && info_code != INFO_CODE.WEBCAM_MUTED
                && info_code != INFO_CODE.MICROPHONE_NOT_AVAILABLE) {

                setDeviceStatus({
                    willShow: true,
                    isDetectingFailed: true,
                    infoCode: info_code,
                })
            }

            dispatch(setDeviceInfoMessage({
                show: true,
                messages: setMessages,
                info_code: info_code,
                no_device: info_code == INFO_CODE.NO_DEVICE_DETECT
            }, 12))
            // }
        }
    }

    const handleOnClose = (nextMove = "", from = null) => {
        setUserDeviceSubmit(false);

        console.log("=> my next move ", nextMove, "from", from)
        if (nextMove) {
            if (nextMove == systemBootMessage.AUDIO || nextMove == "join_without") {
                setTimeout(function () {
                    getStatus(STATUS_FLAG.AUDIO)
                }, 500)

                setTimeout(function () {
                    if (!browserDeviceStatus.audio.status && browserDeviceStatus.audio.infoCode != "") {
                        handleInfoClick(browserDeviceStatus.audio.infoCode, true)
                    } else {
                        // dispatch(setDeviceInfoMessage({
                        //     show: true,
                        //     messages: [],
                        //     info_code: INFO_CODE.ALL_SET
                        // }))
                        showUSubscription(false)
                    }
                }, 2000)

            } else if (nextMove == "form_submit") {
                // if (userRegisterDevice) {
                setUserDeviceSubmit(true);
                // }

                dispatch(getUserBox({
                    activeDevice: true
                }));
                reCheckSystem()
            } else if (nextMove == systemBootMessage.REINIT_SYSTEM) {
                const data = {
                    action: {
                        uniqueID: uniqueId,
                        ipAddress: prejoinScreenDetail.roomname,
                        protocolId: protocolId,
                    },
                    content: 'unpair-device',
                    isBroadcast: true,
                    sender: 'mobile',
                    scope: "recheck-system-prejoin"
                }

                //-------------Prepare logger data -------------
                var log_data = {
                    functionName: '',
                    triggeredBy: 'system',
                    event: data.content,
                    requestData: data,
                    responseData: '',
                    userId: '',
                    boxId: data.action.uniqueID,
                    message: 'Emit to server'
                }
                SaveLog(log_data);
                //-------------------------------------------

                sendData(data);

                setInit(true);

                setTimeout(function () {
                    reCheckSystem()
                }, 8000)

            } else if (nextMove == systemBootMessage.DETECT_DEVICE) {
                if (usersData == null) {
                    console.log("my current flag type ", flagType)
                    if (flagType == STATUS_FLAG.VIDEO) {
                        sessionStorage.setItem("userWebcamDenied", true)
                        setTimeout(function () {
                            getStatus(STATUS_FLAG.DETECT_DEVICE, 8)
                        }, 500)
                    }
                }
            } else if (nextMove == systemBootMessage.WAITING_EXPIRE) {
                console.log("time expire ")
                setDeviceStatus({
                    willShow: true,
                    isDetecting: false,
                    devicePairing: false,
                    devicePaired: false,
                    isDetectingFailed: true,
                    connectFailed: false,
                    infoCode: INFO_CODE.UNKNOWN_ERROR
                })
            } else if (nextMove == systemBootMessage.SUBSCRIPTION_SHOW) {
                if (from == "userConnectedWantBasic") {
                    setShowAllPackage(true)
                } else {
                    setShowAllPackage(false)
                }
                if (usersData == undefined) {
                    setShowAllPackage(true)
                }
                setShowSubscription(true)
            } else if (nextMove == systemBootMessage.SUBSCRIPTION_SHOW_BASIC) {
                console.log("showAudio ", showAudio)
                if (!showAudio) {
                    dispatch(setPrejoinSubscriptionUI({
                        show_basic: true,
                        basic_checking: ct("rta-trmc.premeeting.checkingBasicSubscription"),
                        show_premium: false
                    }))

                    setTimeout(function () {
                        dispatch(setPrejoinSubscriptionUI({
                            show_basic: true,
                            basic_checking: "",
                            show_premium: false
                        }))
                    }, 1000)

                    setTimeout(function () {
                        let subscription = willAskSubscription();
                        if (subscription.basic || subscription.premium) {
                            _showAllSet(5)
                        } else {
                            handleInfoClick(INFO_CODE.BASIC_SUBSCRIPTION)
                        }
                    }, 2000)
                }
            } else if (nextMove == systemBootMessage.DEVICE_RECHECK) {
                dispatch(setPrejoinSubscriptionUI({
                    show_basic: false,
                    basic_checking: "",
                    show_premium: false
                }))

                dispatch(setPrejoinDeviceMessages({
                    show: false,
                    messages: {}
                }, "recheck system subscription"));
                dispatch(setUserDeviceDetecting(false))

                getStatus(STATUS_FLAG.DETECT_DEVICE, 9)
            } else if (nextMove == INFO_CODE.ALL_SET) {
                console.log("alll set from next move", props.joinRoomWithoutDevice)
                // if (props.joinRoomWithoutDevice == false) {
                dispatch(setUserPrejoinAllSet(true))
                if (getBaseConfig("showPreJoiningInConference")) {
                    dispatch(setEnableWebjamModal(true))
                }
                // }
            } else if (nextMove == "without_audio") {

                console.log("without_audio", props.joinRoomWithoutDevice)
                if (props.joinRoomWithoutDevice == false) {
                    dispatch(setJoinRoomWithoutDevice(true, 2))
                    let { uniqueId, conferenceJoined } = getStore(FEATURE_CUSTOM_REDUX)
                    if (getBaseConfig("showPreJoiningInConference") && conferenceJoined) {
                        // let now_time = Math.round(new Date().getTime() / 1000);
                        // sessionStorage.setItem("dv_cnf_tm", JSON.stringify({
                        //     time: now_time,
                        //     id: uniqueId
                        // }))
                    } else {
                        console.log("i will set all 1")
                        dispatch(setDeviceInfoMessage({
                            show: true,
                            messages: [],
                            info_code: INFO_CODE.ALL_SET
                        }, 20))
                    }
                } else {
                    dispatch(setDeviceInfoMessage({
                        show: false,
                        messages: []
                    }, 21))
                }
            }
        }
    }

    const closeSubscription = (type) => {
        // dispatch(setDeviceInfoMessage({
        //     show: true,
        //     messages: [],
        //     info_code: INFO_CODE.ALL_SET
        // }))
        setShowSubscription(false)
        // getStatus(STATUS_FLAG.AUDIO)
    }

    const handleCloseThemeModal = (type = null) => {
        if (type == "reconnect") {
            setTryingToReconnect(false)
        }
        setRecheckingDevice(false)
    }

    const renderPingCalculation = () => {
        let data = null;

        let { prejoinDevicePingCalculation } = props;

        // console.log("prejoinDevicePingCalculation", {prejoinDevicePingCalculation})

        if (prejoinDevicePingCalculation != prejoinDeviceCalculateFlag.DEFAULT) {

            if (prejoinDevicePingCalculation == prejoinDeviceCalculateFlag.WAITING) {
                data = <div
                    className={containerClassName + " d-flex w-100 " + classes.marginTopNgThirtn}
                ><div className="pb-3 w-100 d-flex loading-content" >
                        <span
                            style={{
                                marginLeft: "32px"
                            }}>
                            {ct("rta-trmc.premeeting.waitWhileCalculating")} <SpinnerLoader size="small" />
                        </span>
                    </div>
                </div>
            } else if (prejoinDevicePingCalculation == prejoinDeviceCalculateFlag.RECEIVED) {
                data = <>
                    <div className={containerClassName + " ui-system-status w-100  basic_subs " + classes.marginTopNgThirtn}
                    >
                        <Icon
                            className={`device-icon theme-color-icon`}
                            size={14}
                            src={okSrc}
                        />
                        <span role='heading'
                            style={{
                                marginLeft: "15px"
                            }}
                            className=""
                        >
                            <span>{ct("rta-trmc.premeeting.pingCalculated")}</span>
                        </span>
                    </div>
                </>
            } else {

            }
        }
        return data;
    }

    const handleMultipleDevice = (device_id = null) => {
        // console.log("user selected device ", device_id)
        if (device_id) {
            dispatch(setUserStaticDeviceId(device_id))
        } else {
            dispatch(setPrejoinScreenUserRoute(InvitedUserConfirmFlag.WITHOUT_DEVICE))
            dispatch(setUserDeviceDetecting(false))
            setTimeout(function () {
                getStatus(STATUS_FLAG.DETECT_DEVICE, 10)
            }, 500)
        }
        setShowMultiDevice(false)
    }

    const handleExternalLink = (link = null, target = "_blank") => {
        if (isSocialMobileApp()) {
            console.log("show modal")
            setCopyLink({
                show: true,
                link
            })
        } else {
            if (CURRENT_ROOM_NAME == "dev-testing-room") {
                setShowMobileModalLink(link)
            } else {
                window.open(link, target);
            }
        }
    }

    const handleCloseExternalLink = () => {
        setShowMobileModalLink("")
    }

    let { conferenceJoined } = getStore(FEATURE_CUSTOM_REDUX);
    let showDevicePrejoinText = false;

    if (getBaseConfig("showPreJoiningInConference") && conferenceJoined) {
        showDevicePrejoinText = true;
    }

    return (
        <>
            {!getBaseConfig("showPreJoiningInConference") &&
                <Zendesk zendeskKey={ZENDESK_KEY} {...setting}
                    onLoaded={() => {
                        zE("webWidget:on", "open", function () {
                            dispatch(setZendeskState(true));
                        });
                        zE("webWidget:on", "close", function () {
                            dispatch(setZendeskState(false));
                        });
                        zE('webWidget', 'setLocale', i18next.language);
                    }}
                />
            }

            {copyLink.show && <CopyLinkPop
                link={copyLink.link}
                copyUrl={() => setCopyLink({
                    ...copyLink,
                    isCopied: true
                })}
                isCopied={copyLink.isCopied}
                handleConfirmAction={() => setCopyLink({
                    link: "",
                    show: false,
                    isCopied: false
                })}
            />}

            {showMultiDevice && (props.prejoinScreenUserRoute == "" || props.prejoinScreenUserRoute == InvitedUserConfirmFlag.WITH_DEVICE) && flagType == STATUS_FLAG.DETECT_DEVICE && userBoxStaticDeviceId == "" && <MultipleDeviceList handleMultipleDevice={handleMultipleDevice} deviceList={deviceList} />}

            <ShowDeviceMessageModal handleOnClose={handleOnClose} handleExternalLink={handleExternalLink} />

            {showSubscription && <UserSubscription closeSubscription={closeSubscription} packageList={packageList} showPremium={!showAllPackage} hideCancel={true} />}
            {isRecheckingDevice && <ThemedModal handleClose={() => handleCloseThemeModal("recheck")} message={ct("rta-trmc.premeeting.deviceChangesDetected")} title={ct("rta-trmc.premeeting.changesDetectedTooltip")} />}

            {tryingToReconnect != 0 && <ThemedModal handleClose={() => handleCloseThemeModal("reconnect")} message={tryingToReconnect == 1
                ?
                (getBaseConfig("deviceReconnecting") || ct("rta-trmc.premeeting.deviceReconnecting"))
                : (getBaseConfig("showPreJoiningInConference")
                    ? ct("rta-trmc.premeeting.deviceReconnectingFailedInConference")
                    : (getBaseConfig("deviceReconnectingFailed") || ct("rta-trmc.premeeting.deviceReconnectingFailed")))}

                title={ct("rta-trmc.premeeting.stillChecking")} />}


            {showMobileModalLink && <ThemedModal
                handleClose={handleCloseExternalLink}
                message={showMobileModalLink}
                isLink={true}
                title={ct("rta-trmc.dialogs.infoLink")}
            />}

            <div className="device-room-info-container" datatype={userBoxStaticDeviceId} >
                <div className={conferenceJoined ? "device-room-info-content" : "device-room-info-content device-room-info-content-outside"}>
                    {
                        init
                            ?
                            <span role='heading'
                                style={{
                                    color: "var(--theme-primary-color)",
                                    marginLeft: "15px"
                                }}
                                className={showDevicePrejoinText ? "font18" : "font18 text-justify d-flex"}
                            >
                                {showDevicePrejoinText ? ct("rta-trmc.premeeting.checkingSystemInConference") : ct("rta-trmc.premeeting.checkingSystem")}
                            </span>
                            :
                            <>
                                {showVideo && renderMediaUI("video")}
                                {conferenceJoined && renderInternetUI()}
                                {conferenceJoined && renderDeviceUI_V2()}
                                {conferenceJoined && renderPingCalculation()}
                                {renderBasicSubscriptionUI()}
                                {showAudio && renderMediaUI("audio")}
                            </>
                    }
                </div>
            </div>
        </>
    )
}

function _mapStateToProps(state) {

    let hasVideoTrack = false;

    let hasAudioTrack = false;

    let vTracks = state['features/base/tracks'];
    // console.log("hasVideoTrack ", vTracks)
    if (vTracks) {
        if (vTracks.length) {
            hasVideoTrack = vTracks.filter(e => e.mediaType == "video" && e.videoType == "camera" && e.muted == false).length == 1;
        }
    }

    let allProps = {
        availableDevices: state["features/base/devices"].availableDevices,
        permissions: state["features/base/devices"].permissions,
        mediaAllowed: state['features/base/media'],
        browserDeviceStatus: state[FEATURE_CUSTOM_REDUX_V2].browserDeviceStatus,
        videoTrack: hasVideoTrack,
        audioTrack: hasAudioTrack,
        deviceInfoMessages: state[FEATURE_CUSTOM_REDUX_V2].deviceInfoMessages,
        prejoinStepFlag: state[FEATURE_CUSTOM_REDUX_V2].prejoinStepFlag,
        mediaDeviceOverlay: state[FEATURE_CUSTOM_REDUX_V2].mediaDeviceOverlay,
        prejoinDeviceCode: state[FEATURE_CUSTOM_REDUX_V2].prejoinDeviceCode,
        socketDeviceWaiting: state[FEATURE_CUSTOM_REDUX_V2].socketDeviceWaiting,
        isUserDeviceDetecting: state[FEATURE_CUSTOM_REDUX_V2].isUserDeviceDetecting,
        userPaymentSubscription: state[FEATURE_CUSTOM_PAYMENT].userPaymentSubscription,
        userLoginData: state[FEATURE_CUSTOM_REDUX].userLoginData,
        prejoinDeviceMessages: state[FEATURE_CUSTOM_REDUX_V3].prejoinDeviceMessages,
        prejoinSubscription: state[FEATURE_CUSTOM_REDUX_V3].prejoinSubscription,
        prejoinDevicePingCalculation: state[FEATURE_CUSTOM_REDUX_V3].prejoinDevicePingCalculation,
        userBoxStaticDeviceId: state[FEATURE_CUSTOM_REDUX_V3].userBoxStaticDeviceId,
        userPrejoinAllSet: state[FEATURE_CUSTOM_REDUX_V3].userPrejoinAllSet,
        joinRoomWithoutDevice: state[FEATURE_CUSTOM_REDUX_V2].joinRoomWithoutDevice,
        conferenceJoined: state[FEATURE_CUSTOM_REDUX].conferenceJoined,
        prejoinScreenUserRoute: state[FEATURE_CUSTOM_REDUX_V3].prejoinScreenUserRoute,
        prejoinDeviceConnectTime: state[FEATURE_CUSTOM_REDUX_V3].prejoinDeviceConnectTime,

    }
    return allProps
}

export default connect(_mapStateToProps)(DeviceRoomInfo);